export default {
  common: {
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    none: 'Tidak ada',
    weekdayShort: {
      sun: 'Min',
      mon: 'Sen',
      tue: 'Sel',
      wed: 'Rab',
      thu: 'Kam',
      fri: 'Jum',
      sat: 'Sab'
    },
    logout: 'Keluar',
    messages: 'Pesan',
    download: 'Unduh',
    downloadStatus: {
      downloading: 'Mengunduh file',
      complete: 'Unduhan selesai'
    },
    print: 'Cetak',
    year: 'Tahun',
    pdf: 'PDF',
    excel: 'Excel',
    noData: 'Tidak ada data',
    noDataFound: 'Data tidak ditemukan',
    searchGuide: 'Silakan cari untuk melihat data',
    listLoadCount: 'Dimuat {{loaded}} / {{total}} item',
    endOfList: 'Akhir daftar',
    january: 'Januari',
    february: 'Februari',
    march: 'Maret',
    april: 'April',
    may: 'Mei',
    june: 'Juni',
    july: 'Juli',
    august: 'Agustus',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Desember',
    searching: 'Mencari...',
    enterSearchTerm: 'Silakan masukkan kata pencarian.',
    currentTime: 'Waktu Saat Ini',
    wait: 'Mohon tunggu...',
    noData: 'Tidak ada data tersedia.',
    comingSoon: 'Segera Hadir',
    logoutConfirmTitle: 'Keluar',
    logoutConfirmMessage: 'Apakah Anda yakin ingin keluar?',
    save: 'Simpan',
    delete: 'Hapus',
    deleteSuccess: 'Berhasil dihapus.',
    edit: 'Ubah',
    modify: 'Ubah',
    reset: 'Reset',
    actions: 'Aksi',
    action: 'Action',
    rowsPerPage: 'Baris per halaman',
    of: 'dari',
    allStatus: 'Semua Status',
    allTypes: 'Semua Tipe',
    add: 'Tambah Baru',
    status: 'Status',
    close: 'Tutup',
    more: 'Lainnya',
    saving: 'Menyimpan...',
    updating: 'Memperbarui...',
    retry: 'Coba Lagi',
    deleting: 'Menghapus...',
    success: 'Berhasil',
    remark: 'Remark',
    language: 'Bahasa',
    clearAllFilters: 'Hapus Semua Filter',
    hideFilters: 'Sembunyikan Filter',
    showFilters: 'Tampilkan Filter',
    warning: 'Peringatan',
    information: 'Informasi',
    forbidden: 'Akses Dilarang',
    notFound: 'Sumber Tidak Ditemukan',
    badRequest: 'Permintaan Buruk',
    loading: 'Memuat...',
    processing: 'Memproses...',
    checkingAuthentication: 'Memeriksa Autentikasi...',
    verify: 'Verifikasi',
    preparing: 'Mempersiapkan',
    loggingOut: 'Keluar...',
    startDate: 'Tanggal Mulai',
    endDate: 'Tanggal Selesai',
    excel: 'Excel',
    columnSelection: 'Pemilihan Kolom',
    columnSettings: 'Pengaturan Kolom',
    selectAll: 'Pilih Semua',
    unselectAll: 'Hapus Pilihan Semua',
    totalItems: 'Total Item',
    items: 'item',
    selectedItems: 'Item yang Dipilih',
    itemsSelected: '{{count}} item dipilih',
    noItemsSelected: 'Tidak ada item yang dipilih',
    batchSettings: 'Pengaturan Batch',
    apply: 'Terapkan',
    applied: 'Selesai',
    totalQty: 'Total Qty',
    remainingQty: 'Qty Tersisa',
    workQty: 'Qty Kerja',
    split: 'Bagi',
    existing: 'Sudah Ada',
    processing: 'Memproses...',
    saving: 'Menyimpan...',
    selectDateRange: 'Pilih Rentang Tanggal',
    customRange: 'Rentang Kustom',
    dateRanges: {
      today: 'Hari Ini',
      yesterday: 'Kemarin',
      thisWeek: 'Minggu Ini',
      lastWeek: 'Minggu Lalu',
      thisMonth: 'Bulan Ini',
      lastMonth: 'Bulan Lalu',
      last7Days: '7 Hari Terakhir',
      last30Days: '30 Hari Terakhir',
      last90Days: '90 Hari Terakhir'
    },
    searchType: 'Tipe Pencarian',
    searchKeyword: 'Masukkan kata kunci pencarian',
    all: 'Semua',
    unauthorized: 'Tidak Sah',
    noAccessRights: 'Anda tidak memiliki hak akses ke halaman ini',
    error: 'Kesalahan',
    refresh: 'Segarkan',
    no: 'No',
    date: 'Tanggal',
    complete: 'Selesai',
    register: 'Daftar',
    print: 'Cetak',
    printPreview: 'Pratinjau Cetak',
    start: 'Mulai',
    saveAndClose: 'Simpan dan Tutup',
    statusCode: 'Kode Status',
    underConstruction: 'Sedang Dibangun',
    searchConditions: 'Kondisi Pencarian',
    search: 'Cari',
    searching: 'Mencari...',
    currentTime: 'Waktu Saat Ini',
    noResults: 'Tidak ada hasil ditemukan',
    searchFields: {
      styleNo: 'Nomor Style',
      item: 'Item',
      color: 'Warna',
      customer: 'Customer',
      buyer: 'Buyer',
      dyeingNo: 'Nomor Pencelupan',
      productionNo: 'Nomor Produksi',
      orderNo: 'Nomor Pesanan',
      fileNo: 'Nomor File',
      factory: 'Pabrik',
      name: 'Kontak',
      size: 'Ukuran',
      quantity: 'Quantity',
      status: 'Status',
      search: 'Cari'
    },
    list: {
      title: 'Daftar'
    },
    select: 'Pilih',
    columns: {
      no: 'No',
      id: 'ID',
      date: 'DATE',
      requestAt: 'REQ@',
      recipeAt: 'RECIPE@',
      orderNo: 'No Order',
      size: 'SIZE',
      color: 'COLOR',
      qty: 'QTY',
      cheese: 'CHEESE',
      workType: 'Jenis Pekerjaan',
      misc: 'REMARK',
      confirmType: 'Tipe Konfirmasi',
      stockType: 'Tipe Stok',
      urgent: 'URGENT',
      workProcess: 'Proses Pekerjaan',
      sample: 'SAMPLE',
      workStartDate: 'START DATE',
      dyeingNo: 'DYEING NO',
      recipeId: 'RECIPE ID',
      windingNo: 'WINDING NO',
      targetDate: 'TARGET DATE',
      planDate: 'PLAN DATE',
      delivery: 'DELIVERY',
      rackCode: 'RACK CODE',
      operation: 'OPERATION',
      styleNo: 'STYLE',
      style: 'STYLE',
      item: 'ITEM',
      factory: 'PABRIK',
      remark: 'REMARK',
      productionNo: 'PRODUCTION NO',
      workChees: 'WORK CHEES',
      recipe: 'RECIPE',
      mc: 'M/C',
      workStatus: 'STATUS',
      lot: 'LOT',
      factory: 'FACTORY',
      vendor: 'VENDOR',
      customer: 'CUSTOMER'
    },
    creating: 'Membuat...',
    modifying: 'Memperbarui...',
    yes: 'Ya',
    no: 'Tidak'
  },
  payment: {
    actions: {
      inputPayment: 'Input Pembayaran',
      printStatus: 'Status Invoice Print',
      excelDownload: 'Unduh Excel Status'
    },
    print: {
      dialogTitle: 'Status Invoice',
      title: 'Status Invoice',
      dateOption: 'Opsi Tanggal',
      currentDate: 'Tanggal Saat Ini',
      searchDate: 'Tanggal Pencarian',
      customDate: 'Tanggal Kustom',
      selectDate: 'Pilih Tanggal',
      dateDescription: 'Pilih tanggal untuk status invoice yang akan dicetak',
      printDate: 'Tanggal Cetak',
      companies: 'perusahaan',
      allCurrencies: 'SEMUA',
      yearSelect: 'Pilih Tahun',
      year: '',
      selectedYear: 'Tahun Dipilih',
      currentYear: 'Tahun Sekarang',
      selectDateDescription: 'Pilih tanggal referensi untuk status invoice yang akan dicetak',
      dateSelection: 'Opsi Pemilihan Tanggal',
      selectCustom: 'Pilih tanggal kustom',
      selectedDate: 'Tanggal Terpilih',
      preview: 'Pratinjau',
      generatedBy: 'Dihasilkan oleh Sistem ERP SAMJIN',
      monthInvoice: ' Bulan Invoice',
      qty: 'QTY',
      summary: 'Ringkasan',
      currency: 'Mata Uang',
      totalAmount: 'Jumlah Total',
      headers: {
        company: 'Perusahaan',
        vendor: 'Vendor',
        monthly: 'Bulanan',
        invoice: 'Invoice',
        invoiceNo: 'Nomor',
        qty: 'Quantity',
        amount: 'Jumlah',
        receivedAmount: 'Jumlah Dibayar',
        unpaid: 'Piutang',
        currentMonthInvoice: 'Invoice Bulan {{month}}',
        currentMonthInvoiceQty: 'Jumlah Invoice (QTY)',
        remark: 'Remark'
      },
      totalByCompany: 'Subtotal',
      grandTotal: 'Total',
      paidComplete: 'Lunas',
      noDataAvailable: 'Tidak ada data',
      noDataDescription: 'Tidak ada data invoice yang sesuai dengan kriteria yang Anda pilih.',
      collectionRate: 'Tingkat Koleksi',
      monthlyTrend: 'Tren Bulanan Piutang',
      currencyDistribution: 'Distribusi Mata Uang',
      monthlyUnpaidDetail: 'Detail Piutang Bulanan per Perusahaan',
      invoiceStatusReport: 'Laporan Status Invoice',
      currencySection: 'Bagian',
      vendorNamePlaceholder: 'Nama Vendor',
      vendorSearch: 'Cari vendor...',
      companyCount: '{{count}} perusahaan',
      monthlyTotal: ' Total',
      yearCurrencyStatus: 'Status {{currency}} {{year}}',
      grandTotal: 'Total Keseluruhan',
      summary: 'Ringkasan',
      currencySummary: 'Ringkasan Mata Uang',
      monthlyTrend: 'Tren Bulanan',
      monthSuffix: '',
      totalUnpaid: 'Total Belum Dibayar',
      reportDate: 'Tanggal Laporan',
      executiveSummary: 'Ringkasan Eksekutif',
      totalInvoices: 'Total Faktur',
      totalAmountKRW: 'Total Jumlah (KRW)',
      avgCollectionRate: 'Tingkat Koleksi Rata-rata',
      currencyBreakdown: 'Rincian Mata Uang',
      status: 'Status',
      excellent: 'Sangat Baik',
      good: 'Baik',
      needImprovement: 'Perlu Perbaikan',
      monthlyPerformance: 'Kinerja Bulanan',
      paidAmount: 'Jumlah Dibayar',
      trend: 'Tren',
      invoiceCount: 'Jumlah Faktur',
      yearSuffix: '',
      currencyStatus: 'Status',
      filter: {
        all: 'Semua',
        paid: 'Lunas',
        unpaid: 'Belum Lunas'
      },
      headers: {
        currency: 'Mata Uang',
        invoiceCount: 'Jumlah Invoice',
        totalAmount: 'Total Tagihan',
        paidAmount: 'Jumlah Dibayar',
        unpaidAmount: 'Belum Dibayar',
        collectionRate: 'Tingkat Penagihan',
        vendorName: 'Vendor',
        month: 'Bulan',
        monthSuffix: '',
        invoice: 'Invoice',
        invoiceNo: 'No. Invoice',
        qty: 'Quantity',
        arAmount: 'Jumlah Invoice',
        receivedAmount: 'Jumlah Pembayaran',
        remark: 'Remark',
        date: 'Tanggal',
        status: 'Status'
      },
      paid: 'Lunas',
      unpaid: 'Belum Lunas'
    },
    messages: {
      selectCompanyFirst: 'Silakan pilih perusahaan terlebih dahulu',
      selectItems: 'Silakan pilih perusahaan'
    },
    excel: {
      vendor: 'Vendor',
      month: 'Bulan',
      arAmount: 'Jumlah Piutang\n(Invoice)',
      augustInvoice: 'Invoice Agustus',
      invoiceAge: 'Usia Invoice\n(Jumlah)',
      resultNote: 'Catatan Hasil',
      total: 'Total'
    },
    fields: {
      searchConditions: 'Kondisi Pencarian'
    },
    paymentInput: {
      vendorInfoTitle: 'Informasi Perusahaan',
      vendorName: 'Nama Perusahaan',
      unpaidAmount: 'Piutang (Invoice)',
      unpaidInvoiceTitle: 'Daftar Invoice Belum Dibayar',
      inputSectionTitle: 'Input Pembayaran',
      paymentListTitle: 'Daftar Pembayaran',
      submit: 'Konfirmasi',
      columns: {
        select: 'Pilih',
        actions: 'Actions'
      },
      fields: {
        date: 'Tanggal',
        amount: 'Amount',
        paymentMethod: 'Metode Pembayaran',
        remark: 'Remark'
      },
      methodOptions: {
        bankTransfer: 'Transfer Bank',
        cash: 'Tunai',
        creditCard: 'Kartu Kredit'
      },
      messages: {
        selectInvoices: 'Silakan pilih invoice yang akan dibayar.',
        amountExceedsSelected: 'Jumlah yang dimasukkan ({{amount}}) melebihi total saldo invoice yang dipilih ({{sum}}).',
        deleteConfirm: 'Apakah Anda yakin ingin menghapus pembayaran ini?',
        deleteSuccess: 'Pembayaran berhasil dihapus.',
        deleteFailed: 'Gagal menghapus pembayaran.'
      }
    },
    accountsReceivable: {
      excel: {
        title: 'Status Invoice {{year}}-{{month}}',
        currencyTransaction: 'Transaksi Bank {{currency}}',
        createdDate: 'Dibuat: {{date}}',
        createdDateLabel: 'Dibuat:',
        vendorName: 'Nama Perusahaan',
        month: 'Bulan',
        accountsReceivable: 'Piutang',
        prevMonthInvoice: 'Invoice {{month}}',
        amount: 'Amount',
        qty: 'Qty',
        paymentStatus: 'Status Pembayaran',
        remark: 'REMARK',
        monthFormat: '{{month}}',
        yearMonthFormat: '{{year}}-{{month}}',
        subtotal: 'Subtotal',
        grandTotal: 'Total Keseluruhan',
        summaryTitle: 'Ringkasan {{year}}-{{month}}',
        summaryTitleWithDate: 'Ringkasan {{year}}-{{month}}-{{day}}',
        exchangeRate: 'Nilai Tukar:',
        exchangeRateLabel: 'Nilai Tukar',
        category: 'Kategori',
        currency: 'Mata Uang',
        originalAmount: 'Jumlah Asli',
        convertedUSD: 'Konversi USD',
        convertedIDR: 'Konversi IDR',
        convertedKRW: 'Konversi KRW',
        prevMonthSales: 'Penjualan {{month}}',
        summarySheet: 'Ringkasan',
        summary: 'Ringkasan',
        filename: 'Ringkasan {{year}}-{{month}}',
        filenameWithDate: 'Ringkasan {{year}}-{{month}}-{{day}}'
      }
    },
    companyDetail: {
      totalAr: 'Total Piutang',
      totalReceived: 'Total Diterima',
      balance: 'Saldo',
      invoiceListTitle: 'Daftar Invoice',
      paymentListTitle: 'Daftar Pembayaran',
      columns: {
        invoiceNo: 'No Invoice',
        amount: 'Amount',
        receivedAmount: 'Jumlah Diterima',
        balance: 'Saldo',
        dueDate: 'Jatuh Tempo',
        status: 'Status',
        paymentDate: 'Tanggal Pembayaran',
        currency: 'Mata Uang',
        paymentMethod: 'Metode Pembayaran',
        remark: 'Remark',
        createdBy: 'Dibuat Oleh'
      }
    },
    columns: {
      companyName: 'Perusahaan',
      arAmount: 'Piutang (Invoice)',
      qty: 'Jumlah Invoice (Qty)',
      oldestDate: 'Tanggal Jatuh Tempo Pembayaran'
    }
  }
  ,
  menu: {
    notices: 'Pemberitahuan',
    orderManagement: 'Order',
    orderInput: 'Input Order',
    orderModify: 'Ubah Order',
    workOrder: 'Status Order',
    orderSearch: 'Pencarian Order',
    swatchManagement: 'Kirim & Confirm Sample',
    invoiceIssuance: 'Penerbitan Invoice',
    invoiceManagement: 'Manajemen Invoice',
    paymentManagement: 'Manajemen Pembayaran',
    dyeingManagement: 'Dyeing',
    dyeingWork: 'Permintaan Dyeing',
    dyeingOperation: 'Kerja Dyeing',
    dyeingStatus: 'Status Dyeing',
    recipeSearch: 'Pencarian Resep',
    windingManagement: 'Winding',
    windingRequest: 'Permintaan Winding',
    windingOperation: 'Kerja Winding',
    windingStatus: 'Status Winding',
    shippingDelivery: 'Pengiriman',
    shippingRequest: 'Permintaan Pengiriman',
    shippingOperation: 'Operasi Pengiriman',
    shippingTracking: 'Pelacakan Pengiriman',
    workRequest: 'Permintaan Kerja',
    financeManagement: 'Keuangan',
    financeOverview: 'Ringkasan Keuangan',
    inventoryManagement: 'Inventaris',
    inventory: {
      balance: 'Saldo Inventaris',
      lotBatch: 'LOT Pengelolaan',
      transactionHistory: 'Riwayat Tx Inventaris',
      transfer: 'Transfer Inventaris',
      adjustment: 'Pergerakan Inventaris',
      batchInput: 'Input Batch'
    },
    scmManagement: 'Rantai Pasokan',
    scm: {
      goodsReceipt: 'Pendaftaran GR',
      goodsIssueList: 'Status GI',
      goodsIssueRegistration: 'Pendaftaran GI',
      deliveryInfo: 'Registrasi Pengiriman',
      deliveryStatus: 'Status Pengiriman'
    },
    masterData: 'Data Master',
    masterDataMenu: {
      item: 'Item',
      uomConversion: 'UOM & Konversi',
      location: 'Lokasi Gudang',
      supplier: 'Pendaftaran Pemasok',
      itemTaxon: 'Klasifikasi Item',
      customer: 'Customer',
      buyer: 'Buyer'
    },
    expand: "Perluas Menu",
    collapse: "Ciutkan Menu",
    admin: {
      title: 'Admin',
      userManagement: {
        title: 'Manajemen Pengguna',
        registration: 'Manajemen Pendaftaran',
        resetPassword: 'Reset Kata Sandi',
        accessLogs: 'Log Akses',
        sendMessage: 'Kirim Pesan'
      },
      standardsManagement: {
        title: 'Manajemen Standar',
        threads: 'Manajemen Item',
        companies: 'Manajemen Perusahaan',
        buyers: 'Manajemen Buyer',
        prices: 'Manajemen Harga',
        sizes: 'Manajemen Ukuran(M)',
        machine: 'Manajemen Mesin'
      },
      materialsManagement: {
        title: 'Manajemen Material',
        yarn: 'Manajemen Benang',
        dye: 'Manajemen Dye',
        inventory: 'Manajemen Inventaris'
      },
      bi: {
        title: 'BI',
        startDate: 'Start Date',
        endDate: 'End Date',
        manager: 'Kontak',
        search: 'Search',
        orderDate: 'Order Date',
        vendorName: 'Company',
        itemName: 'Item',
        size: 'Size',
        color: 'Color',
        qty: 'QTY',
        price: 'Unit Price',
        amount: 'Amount',
        grandTotal: 'GRAND TOTAL',
        noData: 'No data found',
        title: 'BI'
      }
    }
  },

  orders: {
    title: 'Input Informasi Dasar Order',
    detailTitle: 'Detail Order',
    modifyTitle: 'Ubah Order',
    tabs: {
      sales: 'Order Umum',
      basic: 'Dasar',
      internalProduction: 'Produksi Internal'
    },
    internal: {
      inputTitle: 'Input Order Produksi Internal',
      listTitle: 'Daftar Order Produksi Internal',
      vendorFixedHint: 'Vendor tetap untuk order produksi internal.'
    },
    list: {
      title: 'Daftar Order',
      searchPlaceholder: 'Cari berdasarkan No Order, Customer, Buyer, Style, dll...'
    },
    search: {
      orderNumberLabel: 'Nomor Order',
      orderNumberPlaceholder: 'Masukkan nomor order (contoh: 202512260)',
      enterOrderNumber: 'Silakan masukkan nomor order.',
      orderOrStyleLabel: 'Nomor Order / Nomor Style',
      orderOrStylePlaceholder: 'Masukkan nomor order atau nomor style (angka saja: cari keduanya, dengan huruf: style saja)',
      enterOrderOrStyle: 'Silakan masukkan nomor order atau nomor style.',
      noResults: 'Tidak ada hasil pencarian.',
      resultsFound: '{{count}} hasil ditemukan.'
    },
    subOrder: {
      detail: {
        title: 'Informasi Detail Sub-Order',
        subOrderId: 'ID Sub-Order',
        fetchError: 'Gagal mengambil informasi sub-order.',
        basicInfo: 'Informasi Dasar',
        detailInfo: 'Informasi Detail',
        dyeingRequest: 'Permintaan Pencelupan',
        dyeingRequestBefore: 'Sebelum Permintaan Pencelupan',
        swatchInfo: 'Informasi Sampel',
        dyeingProcess: 'Proses Pencelupan',
        dyeingProcessEvent: 'Event Proses Pencelupan',
        windingProcess: 'Proses Penggulungan',
        windingProcessEvent: 'Event Proses Penggulungan',
        noProcess: 'Tidak Ada Proses',
        noEvent: 'Tidak Ada Event',
        orderId: 'ID Order',
        buyer: 'Buyer',
        vendor: 'Vendor',
        manager: 'Manajer',
        delivery: 'Pengiriman',
        styleNo: 'No Style',
        fileNo: 'No File',
        orderReceivedDate: 'Tanggal Order Diterima',
        orderCreator: 'Pembuat Order',
        attachedFiles: 'File Lampiran',
        threadName: 'Nama Benang',
        size: 'Ukuran',
        itemName: 'Nama Item',
        color: 'Warna',
        quantity: 'Quantity',
        unitPrice: 'Harga Satuan',
        totalAmount: 'Total Jumlah',
        currency: 'Mata Uang',
        createdAt: 'Dibuat Pada',
        rawYarn: 'Benang Mentah',
        dyeingNo: 'No Pencelupan',
        dyeingRequestType: 'Tipe Permintaan Pencelupan',
        requestCheeseNum: 'Jumlah Keju Permintaan',
        repeat: 'Ulangi',
        urgent: 'URGENT',
        confirm: 'Konfirmasi',
        requester: 'Pemohon',
        requestDate: 'Tanggal Permintaan',
        remark: 'Remark',
        swatchQty: 'Jumlah Sampel',
        swatchSize: 'Ukuran Sampel',
        swatchRemark: 'Catatan Sampel',
        productionId: 'ID Produksi',
        recipeId: 'ID Resep',
        cheeseNum: 'Jumlah Keju',
        machineNo: 'No Mesin',
        status: 'Status',
        dyeingStart: 'Mulai Pencelupan',
        dyeingEnd: 'Selesai Pencelupan',
        storage: 'Penyimpanan',
        lastUpdate: 'Update Terakhir',
        eventName: 'Nama Event',
        author: 'Penulis',
        value1: 'Nilai 1',
        value2: 'Nilai 2',
        windingId: 'ID Penggulungan',
        requestQty: 'Jumlah Permintaan',
        productionQty: 'Jumlah Produksi',
        deliveryQty: 'Jumlah Pengiriman',
        targetDate: 'Tanggal Target',
        plannedDate: 'Tanggal Rencana',
        dryingRequired: 'Pengeringan Diperlukan',
        departureTime: 'Waktu Keberangkatan',
        arrivalTime: 'Waktu Kedatangan',
        giRequest: 'Permintaan Pengiriman',
        giRequestId: 'ID Permintaan Pengiriman',
        plannedDispatchAt: 'Tanggal Pengiriman Direncanakan',
        giRequestLines: 'Informasi Baris Permintaan Pengiriman',
        lineNo: 'No Baris',
        docType: 'Jenis Dokumen',
        docRefNo: 'No Referensi',
        qty: 'Quantity',
        lotId: 'ID LOT',
        locationFrom: 'Lokasi Pengiriman',
        rackFrom: 'Rak',
        giRequestBefore: 'Tidak ada informasi permintaan pengiriman.',
        giLot: 'LOT Pengiriman',
        lotNo: 'No LOT',
        expectedGiAt: 'Tanggal Pengiriman Diharapkan',
        workShift: 'Shift Kerja',
        docId: 'ID Dokumen',
        address: 'Alamat',
        attributes: 'Atribut',
        qtyBox: 'Jumlah Kotak',
        mfgDate: 'Tanggal Produksi',
        expiryDate: 'Tanggal Kedaluwarsa',
        qcStatus: 'Status QC',
        giLotBefore: 'Tidak ada informasi LOT pengiriman.',
        giPost: 'Registrasi Pengiriman',
        giPostId: 'ID Registrasi Pengiriman',
        giPostNo: 'No Dokumen Pengiriman',
        outboundLotNo: 'No LOT Pengiriman',
        giTime: 'Waktu Pengiriman',
        customsDocNo: 'No Dokumen Pabean',
        createdBy: 'Dibuat Oleh',
        giPostBefore: 'Tidak ada informasi registrasi pengiriman.'
      }
    },
    addItem: 'Tambah Item',
    files: {
      selectedCount_one: '{{count}} file dipilih',
      selectedCount_other: '{{count}} file dipilih',
      selectTooltip: 'Unggah file',
      uploading: 'Mengunggah file...',
      loading: 'Memuat file...',
      uploadErrorTitle: 'Unggah File Gagal',
      uploadFailure: 'ID Order: {{orderId}}\nUnggah file gagal.\nFile yang gagal: {{failedFiles}}',
      uploadPartialFailure: 'ID Order: {{orderId}}\nBeberapa file gagal diunggah.\nBerhasil: {{successCount}}/{{totalCount}}\nFile yang gagal: {{failedFiles}}',
      title: 'File Lampiran',
      noFiles: 'Tidak ada file terlampir.',
      existingFile: 'File yang Ada'
    },
    fields: {
      orderNo: 'No',
      customer: 'Customer',
      factory: 'Pabrik',
      contact: 'Kontak',
      buyer: 'Buyer',
      buyer_detail: 'Detail Buyer',
      styleNo: 'No Style',
      fileNo: 'No File',
      orderReceivedDate: 'Tanggal Order Diterima',
      expectedDeliveryDate: 'Tanggal Pengiriman Diharapkan',
      fx_base_currency: 'Mata Uang Dasar FX',
      fx_quote_currency: 'Mata Uang Kutipan FX',
      fx_rate: 'Nilai Tukar FX',
      fetchFxRate: 'Ambil kurs resmi',
      applyFxRate: 'Terapkan kurs',
      fxRateFetchFailed: 'Gagal mengambil kurs.',
      date: 'Tanggal',
      item: 'Item',
      size: 'Ukuran',
      color: 'Warna',
      quantity: 'Quantity',
      currency: 'Mata Uang',
      unitPrice: 'Harga Satuan',
      noPriceData: 'Tidak ada data harga',
      priceSelectTitle: 'Pilih Harga',
      code: 'Kode',
      totalPrice: 'Total Harga',
      actions: 'Actions',
      orderInfo: 'Informasi Order',
      searchConditions: 'Kondisi Pencarian',
      weight: 'Berat',
      items: 'Item',
      orderDate: 'Tanggal Order',
      total: 'Total',
      sum: 'Sum',
      remark: 'Remark',
      searchOrderId: 'Masukkan no order'
    },
    columns: {
      no: 'No',
      date: 'Tanggal',
      orderNo: 'No Order',
      custom: 'Customer',
      buyer: 'Buyer',
      styleNo: 'No Style',
      fileNo: 'FILE NO.',
      vendorName: 'CUSTOMER',
      factory: 'Pabrik',
      name: 'Kontak',
      item: 'Item',
      size: 'Ukuran',
      color: 'Warna',
      dyeNo: 'No Dyeing',
      dyeingStatus: 'Status dyeing',
      yarnEa: 'Jumlah Benang',
      inventory: 'Inventaris',
      totalQty: 'Total Jumlah',
      unitPrice: 'Harga Satuan',
      totalPrice: 'Total Harga',
      swatchDate: 'Tanggal Sampel',
      sampleDate: 'Tanggal Sampel',
      confirmDate: 'Tanggal Konfirmasi',
      shippingDate: 'Tanggal Pengiriman',
      deliveryDate: 'Tanggal GI',
      shippedQty: 'Jumlah Terkirim',
      remainingQty: 'Jumlah Tersisa',
      shippingSampleDate: 'Tanggal Sampel Pengiriman',
      remark: 'Remark',
      status: 'Status',
    },
    validation: {
      required: 'Kolom wajib diisi',
      invalidNumber: 'Angka tidak valid'
    },
    messages: {
      saveSuccess: 'Order berhasil disimpan',
      saveSuccessWithFileUpload: 'ID Order: {{orderId}}\nOrder berhasil disimpan.',
      saveFail: 'Gagal menyimpan Order',
      errorOrderId: 'No Order wajib diisi',
      searchSuccess: 'Informasi order berhasil dimuat',
      deleteSuccess: 'Order berhasil dihapus',
      deleteFail: 'Gagal menghapus Order',
      deleteConfirm: 'Apakah Anda yakin ingin menghapus Order ini?',
      updateSuccess: 'Order berhasil diperbarui'
    },
    delete: {
      title: 'Hapus Order',
      confirmMessage: 'Apakah Anda yakin ingin menghapus Order ini?'
    },
    confirm: {
      title: 'Konfirmasi',
      editTitle: 'Konfirmasi Perubahan'
    },
    viewMode: {
      on: 'Ex',
      off: 'Basic'
    },
    filterAddCurrent: 'Add current selection to filter',
    customerRequired: 'Silakan pilih customer terlebih dahulu.',
    statusTabs: {
      basic: 'Basic',
      detail: 'Detail'
    },
    selfConfirm: 'CFM SAMJIN',
    myOrderFilter: {
      on: 'My',
      off: 'All'
    },
    orderStatus: {
      columns: {
        scmDeliveryStatus: 'Status Pengiriman',
        scmDeliveryDate: 'Tanggal Pengiriman',
        scmDeliveryQty: 'Qty Pengiriman'
      },
      errors: {
        deliveryFetchFailed: 'Gagal memuat informasi pengiriman.'
      }
    },
    columnSettings: 'Pengaturan Kolom',
    status: {
      pending: 'Tertunda',
      swatchWaiting: 'Menunggu Sampel',
      dyeingWaiting: 'Menunggu Dyeing',
      processWaiting: 'Menunggu Proses',
      inProgress: 'Sedang Berjalan',
      rework: 'Pengerjaan Ulang',
      completed: 'Selesai',
      checkingResult: 'Pengecekan Warna',
      dehydrationWaiting: 'Menunggu Pengeringan',
      dehydrationInProgress: 'Pengeringan Sedang Berjalan',
      dehydratingInProgress: 'Dehidrasi Sedang Berjalan',
      locationNeeded: 'Penugasan Lokasi Diperlukan',
      rackingWaiting: 'Menunggu Pengemasan',
      stacking: 'Pengemasan',
      vendorChecking: 'Pengecekan Vendor',
      vendorConfirmed: 'Vendor Dikonfirmasi',
      vendorRejected: 'Vendor Ditolak',
      colorRejected: 'Warna Ditolak',
    },
    confirm: {
      title: 'Konfirmasi',
    }
  },

  swatch: {
    shippingSampleComingSoon: 'Segera hadir',
    flow: {
      noProcess: 'No process history.',
      dyeWaiting: 'Dyeing Waiting',
      dyeingInProgress: 'Dyeing',
      recipeAdding: 'Adding Recipe',
      rackWaiting: 'Storage Waiting',
      redyed: 'Re-dyed',
      workCancelled: 'Cancelled',
      waiting: 'Waiting',
      approved: 'Approved',
      rejected: 'Rejected',
      colorFailed: 'Color Failed',
      send: 'Send',
      sendCancel: 'Cancel Send',
      approve: 'Approve',
      reject: 'Reject',
      resultCancel: 'Cancel Result',
      remaining: 'Sisa Qty',
      undecided: 'Undecided'
    },
    filterTitle: 'Kondisi Pencarian',
    noData: 'Tidak ada data tersedia.',
    fields: {
      customer: 'Customer',
      buyer: 'Buyer',
      styleNo: 'No Style',
      fileNo: 'No File',
      factory: 'Pabrik',
      manager: 'Kontak',
      item: 'Item',
      color: 'Warna',
      quantity: 'Quantity'
    },
    columns: {
      subOrderId: 'Sub Order ID',
      customer: 'Customer',
      buyer: 'Buyer',
      styleNo: 'No Style',
      fileNo: 'No File',
      factory: 'Pabrik',
      manager: 'Kontak',
      item: 'Item',
      color: 'Warna',
      quantity: 'Quantity',
      activeProductionId: 'Active Production ID',
      activeStatus: 'Active Status',
      rejectCount: 'Reject #',
      confirmStatus: 'Confirm',
      actions: 'Actions',
      productionId: 'Production ID',
      status: 'Status',
      updatedAt: 'Updated At',
      dyeingNo: 'DYEING NO'
    },
    vendorConfirm: {
      title: 'Registrasi Konfirmasi Vendor ({{count}} item)',
      selectedItemInfo: 'Informasi Item yang Dipilih',
      dyeingWorkHistory: 'Riwayat Pekerjaan Pencelupan dan Konfirmasi Vendor',
      vendorConfirm: 'Konfirmasi Vendor',
      processing: 'Memproses...',
      pleaseWait: 'Mohon tunggu sebentar',
      register: 'Konfirmasi',
      edit: 'Edit',
      confirm: 'Konfirmasi',
      reject: 'Tolak',
      selfConfirm: 'Self Confirm',
      selfReject: 'Self Reject',
      sendSample: 'Send Sample',
      vendorApprove: 'Vendor Confirm',
      vendorReject: 'Vendor Reject',
      select: 'Select',
      statusChecking: 'Vendor Checking',
      statusStored: 'In Storage',
      statusDone: 'Completed',
      statusRejected: 'Rejected',
      decision: 'Decision',
      undecided: 'Belum Diputuskan',
      rejected: 'Ditolak',
      noItemsToModify: 'Tidak ada item untuk dimodifikasi.',
      vendorConfirmRegistered: 'Konfirmasi vendor telah didaftarkan.',
      registrationFailed: 'Gagal mendaftarkan konfirmasi vendor: {{error}}',
      cancelReview: 'Batalkan Tinjauan',
      cancelFailed: 'Gagal mengirim event pembatalan: {{error}}'
    },
    tableControls: {
      itemsSelected: '{{count}} item dipilih',
      noItemsSelected: 'Tidak ada item yang dipilih',
      vendorConfirmTooltip: 'Registrasi Konfirmasi Vendor ({{count}})',
      columnSettings: 'Pengaturan Kolom',
      selectAll: 'Pilih Semua',
      unselectAll: 'Batalkan Semua'
    },
    detail: {
      title: 'Detail Swatch',
      basicInfo: 'Informasi Dasar',
      statusApproved: 'Disetujui',
      statusRejected: 'Ditolak',
      statusPending: 'Menunggu',
      fields: {
        subOrderId: 'Sub Order ID',
        dyeingNo: 'Dyeing NO',
        customer: 'Customer',
        buyer: 'Buyer',
        styleNo: 'No Style',
        fileNo: 'No File',
        factory: 'Pabrik',
        manager: 'Kontak',
        item: 'Item',
        color: 'Warna',
        quantity: 'Quantity'
      },
      summary: {
        title: 'Ringkasan Proses Dyeing',
        dyeingNo: 'Dyeing NO',
        activeProductionId: 'Active Production ID',
        activeStatus: 'Active Status',
        rejectCount: 'Reject #',
        confirmStatus: 'Confirm',
        confirmed: 'Disetujui',
        notConfirmed: 'Belum Disetujui'
      },
      history: {
        title: 'Riwayat Pekerjaan Dyeing',
        productionId: 'Production ID',
        status: 'Status',
        statusDesc: 'Deskripsi Status',
        updatedAt: 'Updated At',
        remark: 'Remark',
        empty: 'Tidak ada riwayat pekerjaan dyeing.'
      }
    }
  },

  dyeing: {
    title: 'Pekerjaan Dyeing',
    tabs: {
      batchRequest: 'Permintaan Massal',
      internalProduction: 'Produksi Internal',
      requestStatus: 'Status Permintaan'
    },
    assignWork: 'Tetapkan Pekerjaan',
    fields: {
      searchConditions: 'Kondisi Pencarian',
      dyeingNo: 'No Pencelupan',
      productionNo: 'No Produksi'
    },
    requests: {
      request: 'Tetapkan',
      delete: 'Hapus',
      modify: 'Ubah',
      createDyeingNumbers: 'Buat Nomor Dyeing'
    },
    worker: {
      enterUserId: 'Masukkan ID pengguna Anda lalu sambungkan.',
      userId: 'ID Pengguna',
      retryConnection: 'Sambungkan Lagi',
      tokenExpired: 'Koneksi kedaluwarsa. Silakan sambungkan lagi dengan tombol di bawah.',
      tokenFailed: 'Gagal menerima token akses.',
      userNotFound: 'ID pengguna tidak ditemukan.',
      operator: 'Operator',
      showHistory: 'Tampilkan selesai / ditolak',
      invalidCredentials: 'Diperlukan persetujuan administrator.\nSilakan hubungi administrator Anda.',
      networkError: 'Tidak dapat terhubung ke server. Silakan periksa jaringan Anda.',
      loginButton: 'Masuk',
      loadingWork: 'Memuat pekerjaan...',
      recipeLocked: 'Resep tidak dapat diubah saat proses Dyeing',
      searchResultTitle: 'Hasil Pencarian',
      searchNoResult: 'Tidak ada hasil.'
    },
    status: {
      showCompleted: 'Tampilkan selesai'
    },
    operation: {
      editRackCode: 'Ubah Kode Rak',
      rackCodeLabel: 'Kode Rak',
      rackDialog: {
        noProductionId: 'Tidak dapat mengubah kode rak karena production_id tidak ada.',
        saveFailed: 'Gagal menyimpan kode rak.'
      }
    },
    messages: {
      updateSuccess: 'Permintaan pencelupan berhasil diperbarui',
      updateFail: 'Gagal memperbarui permintaan pencelupan',
      abnormalSelection: 'Pilihan mengandung item yang tidak normal',
      deleteSuccess: 'Permintaan pencelupan berhasil dihapus',
      deleteFail: 'Gagal menghapus permintaan pencelupan',
      deleteFailed: 'Gagal menghapus',
      requestSuccess: 'Permintaan pencelupan berhasil dikirim',
      requestFail: 'Gagal mengirim permintaan pencelupan',
      noNewItems: 'Tidak ada item baru yang dipilih',
      onlyNewItems: 'Hanya item baru yang dapat didaftarkan',
      selectItemsToPrint: 'Silakan pilih item untuk dicetak',
      noDyeingItemsSelected: 'Tidak ada item pencelupan yang dipilih',
      missingSampleDetails: 'SAMPLE SIZE atau QTY tidak dimasukkan untuk beberapa item',
      excelSheetWillBeAdded: 'Lembar Excel akan ditambahkan',
      noPrintableItems: 'Tidak ada item untuk dicetak',
      deleteConfirm: 'Apakah Anda yakin ingin menghapus permintaan pencelupan?',
      noItemsSelected: 'Tidak ada item yang dipilih',
      selectItems: 'Silakan pilih item',
      invalidDeleteOrder: 'Item berikut tidak dapat dihapus: {{items}}',
      dyeingReadyCompleted: 'Persiapan pencelupan selesai.',
      dyeingStarted: 'Operasi pencelupan dimulai.',
      dyeingFinished: 'Operasi pencelupan selesai.',
      recipeLoadFailed: 'Gagal memuat informasi resep.',
      saveFailed: 'Gagal menyimpan.',
      recipeModifyCompleted: 'Resep diperbarui dan kembali ke status siap pencelupan.',
      operationCanceled: 'Operasi pencelupan dibatalkan.',
      dehydrationStarted: 'Operasi dehidrasi dimulai.',
      dehydrationFinished: 'Operasi dehidrasi selesai.',
      colorConfirmed: 'Warna telah dikonfirmasi.',
      colorDefectRecorded: 'Dicatat sebagai cacat warna. Ubah resep dan celup ulang (status 94).',
      dyeingAborted: 'Pencelupan dihentikan. Anda dapat membuat nomor kerja baru.',
      workRejected: 'Pekerjaan telah ditolak. Silakan buat item pekerjaan baru',
      locationAssigned: 'Lokasi penyimpanan telah ditetapkan.',
      cannotModifyCompleted: 'Item yang sudah selesai tidak dapat dimodifikasi.',
      cannotModifyInProgress: 'Item yang sedang berlangsung tidak dapat dimodifikasi.',
      cannotDeleteCompleted: 'Item yang sudah selesai tidak dapat dihapus.',
      cannotDeleteInProgress: 'Item yang sedang berlangsung tidak dapat dihapus.',
      recipeSaveSuccess: 'Resep berhasil disimpan.',
      multiRecipeSaveSuccess: '{{successCount}} resep berhasil disimpan.',
      multiRecipeSavePartial: '{{successCount}} resep berhasil, {{failCount}} gagal.',
      recipeSaveFailed: 'Gagal menyimpan resep.',
      productionIdsRequired: 'Tidak ada SPK untuk ditambahkan.',
      addingToExistingRecipe: 'Menambahkan ke resep yang sudah ada...',
      quantityChangeSuccess: 'Jumlah pekerjaan berhasil diubah.',
      selectOneItemForEdit: 'Silakan pilih hanya satu item untuk diedit',
      noRecipeToEdit: 'Tidak ada resep untuk diedit',
      confirmDeleteRecipe: 'Apakah Anda yakin ingin menghapus resep?',
      deleteRecipeFailed: 'Gagal menghapus resep.',
      recipeDeleteSuccess: 'Resep berhasil dihapus.',
      vendorColorConfirmed: 'Warna vendor telah dikonfirmasi.',
      vendorRejected: 'Vendor menolak.',
      rawYarnNotSelected: 'Ada masalah dengan pemilihan benang mentah. Silakan regenerasi atau modifikasi permintaan pewarnaan'
    },
    machine: {
      waiting: 'Menunggu',
      working: 'Bekerja',
      mcLabel: 'M/C {{number}}',
      mcNotAssigned: 'M/C Menunggu',
      selectMachine: 'Tetapkan M/C'
    },
    monitoring: {
      elapsedTime: 'Waktu Berlalu',
      exceededTimeLimit: 'Batas Waktu Terlampaui',
      noActiveDyeing: 'Tidak Ada Dyeing Aktif',
      nextWork: 'Pekerjaan Berikutnya',
      filterStatus: 'Filter Status',
      filterAll: 'Semua Mesin',
      filterIdle: 'Mesin Menganggur',
      filterWorking: 'Mesin Bekerja'
    },
    operation: {
      title: 'Operasi Dyeing',
      operationTab: 'Operasi',
      boilingRecordsTab: 'Catatan Perebusan',
      startWork: 'Mulai Pekerjaan',
      recordResult: 'Catat Hasil',
      resultType: 'Jenis Hasil',
      notes: 'Notes',
      splitOrder: 'Bagi Pesanan',
      totalQuantity: 'Total Jumlah',
      splitQuantity: 'Jumlah Pembagian',
      splitHelp: 'Masukkan jumlah untuk lot pertama',
      noItemsSelected: 'Silakan pilih minimal satu item',
      selectedItemsCount: '{{count}} item dipilih',
      issueWorkNumber: 'Terbitkan Nomor Pekerjaan',
      delete: 'Hapus',
      registerRecipe: 'Daftar Resep',
      processQuantityDialog: {
        title: 'Atur Jumlah Pekerjaan',
        dyeingNo: 'No Pencelupan',
        totalOrderQuantity: 'Total Jumlah Pesanan',
        workQuantity: 'Jumlah Pekerjaan',
        workQuantityHelper: 'Masukkan jumlah yang akan diproses kali ini (desimal diperbolehkan)',
        remainingQuantity: 'Jumlah Tersisa',
        remainingQuantityNote: '(Jumlah tersisa akan otomatis dibuat sebagai item pekerjaan baru)',
        applyExistingRecipe: 'Terapkan Resep yang Ada (Opsional)',
        selectRecipe: 'Pilih Resep',
        doNotApply: 'Jangan Terapkan',
        recipeCopyNote: '* Jika dipilih, resep yang identik dengan resep yang dipilih akan otomatis dibuat.',
        enterWorkQuantity: 'Silakan masukkan jumlah pekerjaan.',
        workQuantityRange: 'Jumlah pekerjaan harus berupa angka antara 0 dan {{max}}.',
        recipeCopyFailed: 'Pekerjaan berhasil dibuat tetapi penyalinan resep gagal.',
        processQuantityFailed: 'Gagal mengatur jumlah pekerjaan.'
      },
      batchDialog: {
        title: 'Buat Massal Pekerjaan/Resep berdasarkan No Dyeing',
        reworkTitleSuffix: ' (Gunakan resep lama {{recipeIdShort}})',
        reworkRunNumber: 'Pembuatan saat ini: recipe run ke-{{n}}',
        reworkLabel: 'Pembuatan saat ini: rework',
        searchByDyeingNo: 'Cari berdasarkan nomor dyeing (dyeing_no_short)',
        unassignedOnly: 'Hanya yang belum ditugaskan',
        recipeSelect: 'Pilih Resep',
        recipeNew: 'NEW',
        machineLabel: 'MC',
        machineNotSet: 'Belum ditentukan',
        selectedItems: 'Item Terpilih',
        searchResults: 'Hasil Pencarian',
        noData: 'Tidak ada hasil pencarian.',
        createWorkOnly: 'Buat Massal Nomor Pekerjaan Saja',
        createWorkAndRecipe: 'Nomor Pekerjaan + Multi Resep',
        noRowsSelected: 'Tidak ada permintaan dyeing yang dipilih, atau hanya item dengan jumlah kerja 0 yang dipilih.',
        submitFailed: 'Terjadi kesalahan saat membuat nomor pekerjaan.',
        headers: {
          dyeingNo: 'DYEING NO',
          style: 'STYLE',
          customer: 'CUSTOMER',
          item: 'ITEM',
          color: 'COLOR',
          reqQty: 'REQ QTY',
          workQty: 'WORK QTY',
          action: 'ACTION'
        },
        tooltips: {
          remove: 'Hapus',
          select: 'Pilih',
          deselect: 'Batalkan pilihan'
        }
      },
      editRecipe: 'Edit Resep',
      printRecipe: 'Cetak Resep',
      printCardsOnly: 'Cetak kartu winding saja',
      extraWindingCards: 'Jumlah kartu winding tambahan (per item)',
      extraWindingCardsRequired: 'Silakan masukkan jumlah kartu tambahan.',
      netWeightMissingTitle: 'net_weight belum terdaftar',
      netWeightMissingBlocked: 'Masukkan net_weight untuk {{items}} di master Item. Cetak resep dibatasi sampai terdaftar.'
    },
    recipeRegisterOption: {
      title: 'Pendaftaran Resep',
      subtitle: 'Pilih metode pendaftaran.',
      new: 'Buat Baru',
      addToExisting: 'Tambah ke Resep yang Ada',
      copyDyeOnly: 'Salin Zat Warna Saja dari Resep yang Ada'
    },
    addToExisting: {
      subtitle: 'Pilih resep yang akan ditambahkan.',
      recipeId: 'ID Resep',
      dyeingNoShortList: 'Daftar Nomor Dyeing',
      noRecipes: 'Tidak ada resep yang ditemukan.',
      loadError: 'Gagal memuat daftar resep.',
      searchByDyeingNo: 'Cari berdasarkan nomor dyeing (dyeing_no_short)',
      searchAriaLabel: 'Cari berdasarkan dyeing_no_short'
    },
    boilingRecords: {
      startDateTime: 'Tanggal/Waktu Mulai',
      endDateTime: 'Tanggal/Waktu Selesai',
      search: 'Cari',
      dateRequired: 'Tanggal/waktu mulai dan selesai diperlukan',
      invalidDateRange: 'Tanggal/waktu mulai harus sebelum tanggal/waktu selesai',
      chartTitle: 'Timeline Periode Perebusan per Mesin',
      noData: 'Tidak ada catatan perebusan untuk periode yang dipilih',
      machineNo: 'Nomor Mesin',
      productionId: 'ID Produksi',
      dyeingNo: 'No Pencelupan',
      recipeId: 'ID Resep',
      boilingStart: 'Mulai Perebusan',
      boilingEnd: 'Selesai Perebusan',
      duration: 'Durasi',
      editDialogTitle: 'Edit Waktu Perebusan',
      modify: 'Ubah',
      modifySuccess: 'Waktu perebusan telah diperbarui.',
      modifyFailed: 'Gagal memperbarui waktu perebusan.',
      zoomHelp: 'Gunakan tombol zoom atau seret grafik untuk menggeser (Zoom: {{zoom}}x)'
    },
    recipe: {
      title: 'Pendaftaran Resep Pencelupan',
      searchOrSelectDyestuff: 'Cari/Pilih Zat Warna',
      addColorReductionRows: 'Tambah Baris Reduksi Warna',
      removeColorReductionRows: 'Hapus Baris Reduksi Warna',
      enterNotes: 'Masukkan catatan...',
      inventoryTx: {
        title: 'Pergerakan stok',
        empty: 'Tidak ada pergerakan stok.',
        loadFailed: 'Gagal memuat pergerakan stok.',
        loadMore: 'Muat lebih banyak',
        noProductionIds: 'Tidak ada production terkait untuk ditampilkan.',
        truncatedWorkIds: 'Lebih dari {{max}} production — menampilkan {{max}} pertama.',
        columns: {
          txTime: 'Waktu',
          txType: 'Jenis',
          item: 'Item',
          qty: 'Qty',
          uom: 'UOM',
          from: 'Dari',
          to: 'Ke'
        }
      },
      totalPercent: 'TOTAL %',
      program: 'PROGRAM',
      addRevision: 'Tambah Revisi',
      viewEdit: 'RESEP',
      search: {
        title: 'Pencarian Resep'
      },
      fields: {
        recipeIdShort: 'ID Resep (Singkat)',
        recipeId: 'ID Resep',
        productionIds: 'ID Produksi',
        dyeStuff: 'DYE STUFF',
        chemicals: 'CHEMICAL',
        acid: 'ACID',
        note: 'Note',
        createdBy: 'Dibuat Oleh',
        createdAt: 'Tanggal Dibuat',
        dyeingNo: 'Nomor Pencelupan'
      },
      errors: {
        fetchFailed: 'Gagal mengambil daftar resep.'
      },
      selectedItemsCount: '{{count}} resep dipilih',
      noItemsSelected: 'Tidak ada resep yang dipilih',
      selectionMode: 'Mode Seleksi',
      clickToSelect: 'Klik untuk memilih',
      clickToDeselect: 'Klik untuk membatalkan pilihan',
      clickToSelectAll: 'Klik untuk memilih/membatalkan semua',
      editRecipe: 'Edit Resep',
      viewRecipe: 'Detail Resep',
      savingMessage: 'Menyimpan informasi resep. Mohon tunggu...',
      multiRecipe: {
        title: 'Pendaftaran Resep Pencelupan Multi',
        sameWork: 'Pekerjaan Sama',
        workingDate: 'TANGGAL KERJA',
        urgent: 'MENDESAK',
        customer: 'CUSTOMER',
        dyeingNo: 'NO PENCELUPAN',
        productionNo: 'NO PRODUKSI',
        color: 'WARNA',
        note: 'NOTE',
        dyeClass: 'Kelas Zat Warna',
        item: 'Item',
        qty: 'Qty',
        net: 'Net(kg)',
        dyestuff: 'Zat Warna',
        percentage: '%',
        gram: 'Gram',
        total: 'TOTAL',
        chemical: 'CHEMICAL',
        rc: 'R/C',
        acid: 'ASAM',
        selectItem: 'Pilih Item',
        acidSection: 'ASAM',
        hydro: 'HYDRO',
        naoh: 'NAOH',
        lot: 'LOT'
      },
      validation: {
        saveConditionFailed: 'Kondisi penyimpanan tidak terpenuhi. Silakan periksa nilai input Anda.',
        invalidRecipe: 'Harap lengkapi resep.',
        noDyestuffAndPercentage: 'Harap masukkan zat warna dan persentase.',
        noDyestuff: 'Harap masukkan zat warna.',
        noPercentage: 'Harap masukkan persentase.',
        missingPercentage: 'Harap masukkan persentase untuk zat warna.',
        invalidDyestuff: 'Zat warna tidak valid.'
      },
      skuWarning: {
        title: 'Peringatan SKU Hilang',
        message: 'Item berikut tidak memiliki SKU dan tidak dapat disimpan:',
        excludedMessage: 'Item tanpa SKU akan dikecualikan dan disimpan.',
        dyestuff: 'Zat Warna',
        chemical: 'CHEMICAL',
        unknown: 'Tidak Diketahui'
      },
      windingCardPrint: {
        title: 'Pengaturan Cetak Kartu Winding',
        waitingItems: 'Menunggu',
        allItemsAssigned: 'Semua item ditetapkan',
        newGroup: 'Grup Baru',
        groupName: 'Grup',
        individual: 'Individual',
        itemsCount: '{{count}} item',
        count: '{{count}}',
        assignInstruction: 'Klik item di atas untuk menetapkan ke grup',
        recipeLabel: 'Resep',
        singleRecipeInfo: '+ {{count}} resep tunggal (cetak langsung)'
      }
    },
    result: {
      approval: 'Persetujuan',
      approve: 'Konfirmasi Pencelupan',
      colorDefect: 'Cacat Warna',
      colorDefectHint: 'Ubah resep dan celup ulang pada nomor kerja yang sama',
      dyeingAbort: 'Kerja dengan Benang Baru',
      dyeingAbortHint: 'Nomor kerja baru perlu dibuat',
      dyeingAbortConfirmTitle: 'Konfirmasi Hentikan Pencelupan',
      dyeingAbortConfirmMessage: 'Hentikan pencelupan tidak dapat dibatalkan.\nYakin ingin menghentikan pencelupan ini?',
      dyeingAbortConfirmProceed: 'Hentikan Pencelupan',
      reject: 'Tolak',
      add: 'Tambah',
      new: 'Baru',
      title: 'Hasil',
      selectResultMessage: 'Silakan pilih hasil pekerjaan dyeing.',
      selectCheckingMessage: 'Silakan pilih hasil konfirmasi pencelupan.'
    },
    location: {
      title: 'Lokasi Penyimpanan',
      titleRegister: 'Daftar Lokasi Penyimpanan',
      enterLocationMessage: 'Silakan masukkan lokasi penyimpanan untuk pekerjaan yang selesai.',
      locationLabel: 'Lokasi Penyimpanan',
      locationPlaceholder: 'mis., A1, B2-3, C5',
      locationHelperText: 'Silakan masukkan kode lokasi penyimpanan.',
      confirmMessage: 'Apakah Anda ingin menyimpan di lokasi "{{location}}"?',
      applyToAllDyeingNo: 'Terapkan lokasi yang sama ke semua nomor dyeing'
    },
    success: {
      machineAssigned: 'Mesin berhasil ditetapkan',
      operationStarted: 'Operasi berhasil dimulai',
      resultRecorded: 'Hasil berhasil dicatat',
      orderSplit: 'Pesanan berhasil dibagi'
    },
    errors: {
      noItemsSelected: 'Silakan pilih minimal satu item',
      noMachineAssigned: 'Silakan tetapkan mesin untuk semua item yang dipilih',
      machineAssignFailed: 'Gagal menetapkan mesin',
      operationStartFailed: 'Gagal memulai operasi',
      dyeingReadyFailed: 'Gagal menandai siap pencelupan.',
      dyeingStartFailed: 'Gagal memulai operasi pencelupan.',
      recipeModifyFailed: 'Gagal menerapkan modifikasi resep.',
      machineAlreadyInUse: 'Mesin {{machine}} sedang menjalankan resep {{recipe}}.\nMohon tunggu hingga operasi sekarang selesai.',
      resultRecordFailed: 'Gagal mencatat hasil',
      dyeingAbortFailed: 'Gagal menghentikan pencelupan',
      orderSplitFailed: 'Gagal membagi pesanan',
      noRecipeToPrint: 'Tidak ada resep untuk dicetak.',
      bulkPrintFailed: 'Gagal mencetak resep secara massal.',
      processEventFailed: 'Gagal memproses event pencelupan.',
      eventConflict: 'Operator lain sedang memproses resep ini. Coba lagi sebentar.',
      eventJobTimeout: 'Proses tidak selesai tepat waktu. Segarkan daftar dan periksa status.',
      eventApplyFailed: 'Gagal. Status tidak berubah.',
      inventoryPreflightFailed: 'Stok tidak mencukupi.',
      inventoryFailureLine: '{{itemName}} perlu {{required}} / tersedia {{available}}',
      inventoryFailureLineWithLocation:
        '{{itemName}} ({{locationName}} #{{locationId}}) perlu {{required}} / tersedia {{available}}',
      inventoryLocationNotFound: 'Lokasi penyimpanan tidak ditemukan: {{locationName}} (#{{locationId}})'
    },
    eventProcessing: 'Sedang diproses…',
    status: {
      showCompleted: 'Tampilkan selesai',
      title: 'Status Dyeing',
      statusTab: 'Status',
      monitoringTab: 'Pemantauan Waktu Nyata',
      statisticsTab: 'Statistik',
      inventoryTab: 'Stok',
      inventoryStartDate: 'Mulai',
      inventoryEndDate: 'Selesai',
      inventoryOpening: 'Saldo awal',
      inventoryClosing: 'Saldo akhir',
      inventoryReceipt: 'Masuk',
      inventoryIssue: 'Keluar',
      inventoryProduction: 'Produksi',
      inventoryConsume: 'Konsumsi',
      inventoryTotal: 'Total',
      inventoryDate: 'Tanggal',
      inventoryRangeRequired: 'Pilih tanggal mulai dan selesai.',
      inventoryRangeTooLong: 'Periode maksimal 31 hari.',
      inventoryRangeInvalid: 'Tanggal selesai lebih awal dari tanggal mulai.',
      inventorySnapshotPending: 'Tutup buku bulanan belum siap.',
      inventoryStale: 'Transaksi susulan belum tercermin',
      inventoryCloseTz: 'Zona waktu tutup {{tz}}',
      inventoryCalendarNote: '{{start}} – {{end}} · tanggal Jakarta ({{tz}})',
      inventoryMixedUom: 'Jumlah kuantitas dari satuan yang berbeda.',
      inventoryLoadFailed: 'Gagal memuat stok.',
      inventoryLocationMissing: 'Lokasi tidak ditemukan. {{detail}}',
      inventorySnapshotMonth: 'Snapshot awal {{month}}',
      inventorySnapshotAt: 'Snapshot dibuat {{at}}',
      machineQueueTab: 'Antrian Mesin',
      machineQueueTitle: 'MACHINE QUEUE',
      queueReorder: 'Urutkan',
      queueReordering: 'Mengurutkan...',
      queueInProgress: 'Sedang Berjalan',
      queueWaiting: 'Menunggu',
      queuePlacement: 'Mesin Ditugaskan',
      queueReady: 'Benang Siap',
      queueDyeing: 'Proses Dyeing',
      queuePostDyeing: 'Pengeringan/Penyimpanan',
      queueDelivery: 'Delivery',
      queueReadOnlyHint: 'Hanya departemen admin dan dyeing yang dapat mengubah urutan antrian',
      queueMoveSuccess: 'Urutan antrian berhasil diubah',
      queueMoveFailed: 'Gagal mengubah urutan antrian',
      queuePollNote: 'Segarkan otomatis setiap 30 detik',
      queueEmptyMachine: 'Tidak ada pekerjaan antrian',
      queueActiveMachines: 'Mesin aktif',
      queueDetailItems: 'Item',
      queueDetailDyeingNo: 'Dyeing No',
      queueDetailStyle: 'Style',
      queueDetailColor: 'Color',
      queueDetailCustomer: 'Customer',
      queueDetailDyeingRequestAt: 'Waktu Permintaan Pewarnaan',
      queueDetailGiRequestAt: 'Waktu Permintaan GI',
      queueDetailBoiling: 'Mulai Perebusan',
      queueDetailRunInProgress: 'Dalam Proses',
      queueDetailRunWaiting: 'Menunggu',
      queueDetailRecipeModifying: 'Sedang Merevisi Resep',
      queueDetailRecipeModified: 'Resep Diperbarui',
      queueDetailLoadFailed: 'Gagal memuat detail',
      queueUrgentOverride: 'Timpa status urgent',
      queueUrgentOverrideFailed: 'Gagal mengubah status urgent',
      statisticsComingSoon: 'Grafik statistik segera hadir',
      expand: 'Perluas (+{{count}})',
      collapse: 'Ciutkan',
      dataRangeNote: '※ Tampilan default menampilkan 7 hari terakhir. Tanggal lebih lama akan dimuat saat dipilih.',
      completedDataNote: '※ Riwayat selesai diambil untuk tanggal yang dipilih sesuai zona waktu browser.',
      shiftLegend: 'Shift',
      excelRangeTitle: 'Periode Unduhan Excel',
      shift1: '1 Shift (06:00–14:00)',
      shift2: '2 Shift (14:00–22:00)',
      shift3: '3 Shift (22:00–06:00)',
      pending: 'Tertunda',
      inProgress: 'Sedang Berjalan',
      completed: 'Selesai',
      idle: 'Menganggur',
      working: 'Bekerja',
      reject: 'REJECT',
      dyeingAborted: 'DYEING ABORT',
      dyeingAbortedHint: 'Pencelupan dihentikan — nomor kerja baru dapat dibuat',
      modifying: 'MODIFYING',
      rackWaiting: 'Menunggu Rak',
      rackWaitingLocation: 'Pencelupan Dikonfirmasi [Menunggu Lokasi]',
      dehydrationComplete: 'Dehidrasi Selesai',
      approvalComplete: 'Persetujuan Selesai',
      dehydrating: 'Dehidrasi',
      swatchWaiting: 'Menunggu Pengiriman Swatch',
      dyeingComplete: 'Pencelupan Selesai',
      dyeingInProgress: 'Pencelupan Sedang Berjalan',
      workWaiting: 'Menunggu',
      rawYarnPreparing: 'Persiapan Benang',
      recipeModifying: 'Ubah Resep',
      preparing: 'Mempersiapkan',
      preparationNeeded: 'Semua Kondisi Diperlukan',
      approvalNeeded: 'Menunggu Input Hasil',
      dehydrationPending: 'Dehidrasi Tertunda',
      locationPending: 'Penetapan Lokasi Tertunda',
      dehydratingShort: 'Dehidrasi',
      dyeingShort: 'Dyeing',
      selectMachine: 'Silakan pilih mesin.',
      waitingForAssignment: 'Menunggu Penetapan Pekerjaan',
      ready: 'Siap',
      dyeingCompleteChecking: 'Pencelupan Selesai [Memeriksa]',
      approvalCompleteDehydrationWaiting: 'Warna Disetujui [Menunggu Dehidrasi]',
      dehydrationCompleteLocationWaiting: 'Dehidrasi Selesai [Menunggu Lokasi]',
      completedWithLocation: 'Selesai [{{location}}]',
      vendorChecking: 'Checking Vendor',
      vendorConfirmed: 'Vendor Dikonfirmasi',
      vendorRejected: 'Vendor Ditolak',
      filter: {
        pending: 'Sebelum Pekerjaan',
        ready: 'Pekerjaan Siap',
        dyeing: 'Pencelupan',
        approval: 'Periksa Hasil',
        dehydration: 'Dehidrasi',
        location: 'Menunggu Lokasi',
        completed: 'Pekerjaan Selesai',
        rejected: 'REJECT'
      }
    },
    actions: {
      assignLocation: 'Tetapkan Lokasi',
      markDyeingReady: 'Siap Pencelupan',
      prepareComplete: 'Siap',
      recipeModifyDone: 'Selesai Ubah',
      startDehydration: 'Mulai Dehidrasi',
      finishDehydration: 'Selesaikan Dehidrasi',
      viewResults: 'Lihat Hasil',
      enterResults: 'Masukkan Hasil',
      startOperation: 'Mulai Operasi'
    },
    tooltip: {
      readyCondition: 'Jumlah, resep, dan mesin harus ditetapkan sebelum menandai siap pencelupan.',
      startCondition: 'Pencelupan dapat dimulai setelah siap pencelupan selesai.'
    },
    print: {
      dyeingRequest: 'DYEING REQUEST',
      leader: 'Leader',
      manager: 'Manager',
      itemSize: 'ITEM_SIZE',
      qty: 'QTY',
      dyeNo: 'DYE NO.',
      color: 'COLOR',
      cheese: 'CHEES',
      priority: 'PRIORITY',
      urgent: 'URGENT',
      standard: 'STANDARD',
      data: 'DATA',
      dyeingBT: 'DYEING B/T',
      remark: 'REMARK',
      dyeingLabel: 'DYEING LABEL',
      print: 'Instruksi Kerja',
      exportToExcel: 'Ekspor ke Excel',
      excel: 'Excel',
      printLabels: 'Cetak Label',
      label: 'Label',
      printConfirmationCard: 'Cetak Kartu Konfirmasi',
      sheet: 'Sheet',
      printDyeingInstructions: 'Cetak Instruksi Dyeing',
      printConfirmSheet: 'Cetak Sheet Konfirmasi',
      selectedItemsCount: '{{count}} item dipilih',
      noItemsSelected: 'Tidak ada item yang dipilih',
      preparingPrint: 'Mempersiapkan Cetak...',
      printReady: 'Cetak Siap',
      confirmCard: {
        title: 'Pengaturan Cetak Kartu Konfirmasi',
        selectedItems: 'Item yang Dipilih: {{count}}',
        templateSelect: 'Pilih Template',
        includeBuyerDetail: 'Sertakan Detail Buyer',
        templates: {
          standard: 'STANDARD',
          hansoll: 'HANSOLL',
          seaA: 'SEA-A',
          shinsung: 'SHINSUNG',
          mca: 'MCA',
          hyomyung: 'HYOMYUNG',
          harrysYoungIl: 'Harrys Pack Jaya & Young IL'
        },
        hyomyungOption: {
          title: 'HYOMYUNG Option Select',
          option1: 'Option 1 - Standard',
          option2: 'Option 2 - Compact'
        },
        description: {
          line1: 'Cetak kartu konfirmasi dengan template yang dipilih.',
          line2: 'Hingga 10 item dapat ditampilkan per halaman.'
        },
        orderAdjustment: 'Urutan Cetak',
        totalItems: 'Total {{count}}',
        orderInstruction: 'Sesuaikan urutan dengan menyeret atau menggunakan tombol panah.',
        additionalText: {
          placeholder: 'Teks Tambahan',
          options: {
            first: '(1ST)',
            second: '(2ND)',
            third: '(3RD)',
            fourth: '(4TH)',
            fifth: '(5TH)',
            sample: '(SAMPLE)',
            bulk: '(BULK)'
          }
        },
        search: {
          placeholder: 'Dyeing No, Style',
          button: 'Cari',
          add: 'Tambah',
          added: 'Ditambahkan',
          addAll: 'Tambah Semua',
          noResult: 'Tidak ada hasil.',
          resultCount: '{{count}} hasil'
        }
      }
    },
    modals: {
      createDyeingNumbers: {
        title: 'Buat Nomor Pencelupan',
        description: 'Buat nomor pencelupan untuk item yang dipilih.',
        submit: 'Buat',
        cheeseBaseValue: 'Standar: {{value}}'
      },
      modifyDyeingNumbers: {
        title: 'Ubah Permintaan Pencelupan',
        description: 'Ubah informasi permintaan pencelupan untuk item yang dipilih.',
        submit: 'Ubah',
        cheeseBaseValue: 'Standar: {{value}}'
      }
    },
    filter: {
      showAll: 'Semua',
      showDyeingOnly: 'Dyeing No O',
      showWithoutDyeing: 'Dyeing No X'
    },
    tableRow: {
      work: '작업',
      number: 'No',
      enterNumber: '번호 입력',
      confirm: '컨펌',
      stock: '재고',
      size: 'SIZE',
      pcs: 'PCS',
      remark: 'REMARK'
    },
    workType: {
      swatch: 'SWATCH',
      repeat: 'REPEAT'
    },
    confirmationType: {
      vendor: 'VENDOR',
      self: 'SELF'
    },
    stockType: {
      na: 'N/A',
      stock_black: 'STOCK BLACK',
      opt: 'OPT',
      opt_white: 'OPT',
      ivory: 'IVORY'
    },
    table: {
      dyeingNo: 'DYEING NO',
      style: 'STYLE',
      item: 'ITEM',
      color: 'COLOR',
      productionNo: 'PRODUCTION NO',
      workChees: 'WORK CHEES',
      recipe: 'RECIPE',
      mc: 'M/C',
      workStatus: 'STATUS',
      action: 'ACTION',
      lot: 'LOT'
    },
    machineAssigned: 'Mesin berhasil ditetapkan',
    machineUnassigned: 'Mesin berhasil dihapus',
    deleteDialog: {
      title: 'Konfirmasi Penghapusan Item',
      message: 'Apakah Anda yakin ingin menghapus item ini? Tindakan ini tidak dapat dibatalkan.'
    }
  },

  winding: {
    title: 'Kerja Winding',
    qtyEditHint: 'Klik untuk mengubah jumlah label',
    tabs: {
      batchRequest: 'Permintaan Massal',
      requestStatus: 'Status Permintaan',
      status: 'Status',
      inventory: 'Stok'
    },
    requestTitle: 'Permintaan Winding',
    assignWork: 'Tetapkan Pekerjaan',
    columns: {
      no: 'No',
      date: 'DATE',
      styleNo: 'STYLE',
      subOrderId: 'SubOrderID',
      customer: 'CUSTOMER',
      customerName: 'Nama Customer',
      productionNo: 'PRODUCTION NO',
      windingId: 'WINDING NO',
      wdQty: 'QTY',
      urgent: 'URGENT',
      remark: 'MISC',
      targetDate: 'DATE',
      dyeingNo: 'DYEING NO',
      windingNo: 'WINDING NO',
      item: 'ITEM',
      size: 'SIZE',
      qty: 'QTY',
      color: 'COLOR',
      cheezRackCode: 'LOC',
      workProcess: 'WORK PROCESS',
      vendor: 'VENDOR',
      dryingRequired: 'DRYING',
      factory: 'FACTORY',
      operation: 'OPERATION',
      planDate: 'PLAN DATE',
      delivery: 'DELIVERY',
      rackCode: 'RACK CODE'
    },
    summary: {
      producedQty: 'QTY Produksi'
    },
    operation: {
      pending: 'Menunggu',
      waiting: 'Menunggu',
      processing: 'Sedang Berlangsung',
      drying: 'Pengeringan',
      deliveryWaiting: 'Pengiriman Menunggu',
      deliveryProcessing: 'Pengiriman Sedang Berlangsung',
      completed: 'Selesai',
      cancelled: 'Dibatalkan',
      editStartEndTitle: 'WINDING MODIFICATION',
      editStartEndTooltip: 'WINDING MODIFICATION'
    },
    status: {
      waiting: 'Menunggu',
      inProgress: 'Sedang Berlangsung',
      drying: 'Pengeringan',
      completed: 'Selesai',
      cancelled: 'Dibatalkan'
    },
    messages: {
      requestSuccess: 'Permintaan berhasil diproses',
      requestFail: 'Gagal memproses permintaan',
      noNewItems: 'Tidak ada item baru yang dipilih',
      deleteFail: 'Gagal menghapus pekerjaan winding',
      selectedItemsCount: '{{count}} item dipilih',
      noItemsSelected: 'Tidak ada item yang dipilih',
      noPrintableItems: 'Tidak ada item yang dapat dicetak',
      quantityChangeSuccess: 'Jumlah pekerjaan berhasil diperbarui',
      quantityChangeFailed: 'Gagal memperbarui jumlah pekerjaan',
      createSuccess: 'Pekerjaan winding berhasil dibuat',
      createFailed: 'Gagal membuat pekerjaan winding',
      updateSuccess: 'Pekerjaan winding berhasil diperbarui',
      updateFailed: 'Gagal memperbarui pekerjaan winding',
      editSuccess: 'Pekerjaan winding berhasil diedit',
      deleteSuccess: 'Pekerjaan winding berhasil dihapus',
      deleteFailed: 'Gagal menghapus pekerjaan winding',
      saveSuccess: 'Perubahan berhasil disimpan',
      saveFailed: 'Gagal menyimpan perubahan',
      noChanges: 'Tidak ada perubahan yang dibuat',
      invalidQuantity: 'Jumlah tidak valid',
      insufficientQuantity: 'Jumlah tersisa tidak mencukupi',
      selectItems: 'Silakan pilih item',
      selectItemsToCreate: 'Silakan pilih item untuk dibuat',
      selectItemsToEdit: 'Silakan pilih item untuk diedit',
      selectItemsToDelete: 'Silakan pilih item untuk dihapus',
      selectItemsToPrint: 'Silakan pilih item untuk dicetak',
      confirmDelete: 'Apakah Anda yakin ingin menghapus item yang dipilih?',
      confirmSave: 'Apakah Anda yakin ingin menyimpan perubahan?',
      cannotDeleteCompleted: 'Tidak dapat menghapus pekerjaan yang selesai',
      cannotEditCompleted: 'Tidak dapat mengedit pekerjaan yang selesai',
      cannotDeleteInProgress: 'Tidak dapat menghapus pekerjaan yang sedang berlangsung',
      cannotEditInProgress: 'Tidak dapat mengedit pekerjaan yang sedang berlangsung',
      batchCreateSuccess: '{{count}} item berhasil dibuat',
      batchUpdateSuccess: '{{count}} item berhasil diperbarui',
      batchDeleteSuccess: '{{count}} item berhasil dihapus',
      batchCreateFailed: 'Pembuatan batch gagal',
      batchUpdateFailed: 'Pembaruan batch gagal',
      batchDeleteFailed: 'Penghapusan batch gagal',
      validationError: 'Silakan periksa nilai input Anda',
      networkError: 'Terjadi kesalahan jaringan',
      serverError: 'Terjadi kesalahan server',
      unauthorized: 'Akses tidak diizinkan',
      forbidden: 'Akses dilarang',
      notFound: 'Data yang diminta tidak ditemukan',
      timeout: 'Waktu permintaan habis',
      unknownError: 'Terjadi kesalahan yang tidak diketahui'
    },
    filter: {
      showAll: 'Semua',
      showWindingOnly: 'No Winding',
      showWithoutWinding: 'No Winding'
    },
    confirmDialog: {
      title: 'Konfirmasi',
      message: 'Apakah Anda yakin ingin memproses permintaan?'
    },
    fields: {
      searchConditions: 'Kondisi Pencarian'
    },
    print: {
      selectedItemsCount: '{{count}} item dipilih',
      noItemsSelected: 'Tidak ada item yang dipilih',
      workOrderButton: 'Perintah Kerja',
      workOrderTitle: 'Winding Request',
      label: 'Label',
      shippingMark: 'Shipping Mark',
      labelDialog: {
        title: 'Cetak Label',
        description: '{{count}} item dipilih / Total {{total}} label',
        subOrderNo: 'SUB ORDER',
        printQty: 'JML CETAK',
        remark: 'REMARK',
        printButton: 'Cetak',
        noItems: 'Tidak ada item yang bisa dicetak.'
      },
      workOrderData: {
        selectDate: 'Pilih Tanggal',
        targetDate: 'Tanggal Target',
        totalQty: 'Total Qty',
        windingLeader: 'Winding Leader'
      },
      workOrder: {
        title: 'Perintah Kerja',
        items: 'item',
        totalItems: 'Total {{count}} item',
        targetDate: 'Tanggal Target',
        workDate: 'Tanggal Kerja',
        planDate: 'Tanggal Kerja',
        cone: 'cone',
        noTodayWork: 'Tidak ada pekerjaan yang dijadwalkan untuk hari ini',
        orderInstruction: 'Ditampilkan sesuai urutan kerja',
        noDataMessage: 'Tidak ada data kerja untuk tanggal yang dipilih',
        signature: 'Tanda Tangan',
        date: 'Tanggal',
        columns: {
          no: 'NO',
          windingNo: 'WINDING NO',
          dyeingNo: 'DYEING NO',
          styleNo: 'STYLE NO',
          vendor: 'VENDOR',
          factory: 'FACTORY',
          item: 'ITEM',
          color: 'COLOR',
          qty: 'QTY',
          size: 'SIZE',
          remark: 'REMARK'
        }
      },
      printTrimCard: 'Cetak Trim Card',
      trimCard: {
        title: 'Pengaturan Cetak Trim Card',
        selectedItems: 'Item Dipilih: {{count}}',
        templateSelect: 'Pilih Template',
        includeBuyerDetail: 'Sertakan Detail Buyer',
        templates: {
          standard: 'STANDARD',
          saeA: 'SAE-A',
          ubase: 'UBASE',
          shinwon: 'SHINWON',
          hyomyung: 'HYOMYUNG',
          hansoll: 'HANSOLL'
        },
        hyomyungOption: {
          title: 'Pilih Opsi HYOMYUNG',
          option1: 'Opsi 1 - Standar',
          option2: 'Opsi 2 - Kompak'
        },
        description: {
          line1: 'Cetak trim card dengan template yang dipilih.',
          line2: 'Maksimal 10 item per halaman.'
        },
        orderAdjustment: 'Pengaturan Urutan Cetak',
        totalItems: 'Total {{count}} item',
        orderInstruction: 'Atur urutan dengan drag atau tombol panah.',
        additionalText: {
          placeholder: 'Teks Tambahan',
          options: {
            first: '(1ST)',
            second: '(2ND)',
            third: '(3RD)',
            fourth: '(4TH)',
            fifth: '(5TH)',
            sample: '(SAMPLE)',
            bulk: '(BULK)'
          }
        }
      }
    },
    schedule: {
      title: 'Penyesuaian Jadwal',
      adjustButton: 'Penyesuaian Jadwal',
      batchChange: 'Ubah Jadwal Massal',
      workOrder: 'Daftar Kerja',
      changeDate: 'Ubah Tanggal',
      noData: 'Tidak Ada Data',
      updateFailed: 'Gagal memperbarui jadwal',
      dateRangeError: 'Kesalahan Rentang Tanggal',
      dateRangeErrorMessage: 'Tanggal yang dipilih di luar periode pencarian.',
      dateRangeDetail: 'Periode pencarian: {{startDate}} ~ {{endDate}}',
      dateRangeInstruction: 'Silakan pilih tanggal dalam periode pencarian.',
      saveFailed: 'Gagal Menyimpan',
      saveFailedMessage: 'Terjadi kesalahan saat menyimpan perubahan jadwal.',
      saveFailedInstruction: 'Silakan coba lagi nanti.',
      itemsSelected: '{{count}} dipilih'
    }
  },

  shipping: {
    title: 'Pekerjaan Pengiriman',
    assignWork: 'Tetapkan Pekerjaan',
    columns: {
      no: 'No',
      date: 'Tanggal',
      styleNo: 'No Style',
      productionNo: 'No Produksi',
      shippingId: 'No Pengiriman',
      shippingQty: 'QTY',
      urgent: 'Mendesak',
      remark: 'REMARK',
      targetDate: 'Tanggal Target',
      dyeingNo: 'No Dyeing',
      buyer: 'Buyer',
      manager: 'Manajer',
      vendor: 'Vendor',
      fileNo: 'No File',
      threadName: 'Nama Benang',
      color: 'Warna',
      size: 'Ukuran',
      qty: 'QTY',
      shippingTargetDate: 'Tanggal Target',
      truckName: 'Truk',
      remark: 'REMARK',
      windingNo: 'No Winding',
      timeOfDeparture: 'Pergi',
      timeOfArrival: 'Datang',
      ctNo: 'C/T NO',
      tracking: 'Pelacakan'
    },
    filter: {
      showAll: 'Tampilkan Semua',
      showShippingOnly: 'Dengan Tanggal Pengiriman',
      showWithoutShipping: 'Tanpa Tanggal Pengiriman',
      showCompleted: 'Pengiriman Selesai',
      showInProgress: 'Pengiriman Sedang Berlangsung/Menunggu'
    },
    fields: {
      searchConditions: 'Kondisi Pencarian'
    },
    tracking: {
      completed: 'Dikirim',
      in_progress: 'Dalam Pengiriman',
      not_started: 'Menunggu'
    },
    selectedItemsCount: '{{count}} item dipilih',
    noItemsSelected: 'Tidak ada item yang dipilih',
    printCustomsDocuments: 'Dokumen Bea Cukai',
    printInvoice: 'Surat Jalan',
    print: {
      noItemsSelectedForPrint: 'Silakan pilih item untuk dicetak.',
      noValidItemsSelected: 'Tidak ada data valid ditemukan di item yang dipilih.',
      downloadSuccess: 'File Excel telah diunduh.',
      downloadFailed: 'Pengunduhan file gagal.',
      downloading: 'Mengunduh file',
      downloadComplete: 'Unduhan selesai'
    },
    invoice: {
      printPreview: 'Surat Jalan',
      splitBy: 'Per',
      splitByCustomer: 'CUSTOMER',
      splitByManager: 'Kontak',
      print: 'Cetak',
      pdf: 'PDF',
      to: 'Kepada',
      documentNumber: 'No Dokumen',
      apply: 'Terapkan',
      loading: 'Mempersiapkan surat jalan...'
    },
    dialog: {
      createShippingRequest: {
        title: 'Permintaan Pengiriman',
        description: 'Buat permintaan pengiriman untuk {{count}} item yang dipilih.',
        submit: 'Buat Permintaan Pengiriman'
      },
      editOperations: {
        title: 'Operasi Pengiriman',
        description: 'Edit informasi operasi untuk {{count}} item yang dipilih.',
        submit: 'Kirim'
      },
      bulkSettings: {
        title: 'Pengaturan Massal',
        targetDate: 'Tanggal Target Pengiriman',
        truck: 'Nama Truk',
        remark: 'Remark',
        departure: 'Waktu Keberangkatan dan Tanggal',
        arrival: 'Waktu Kedatangan dan Tanggal',
        applyAll: 'Terapkan ke Semua',
        apply: 'Terapkan',
        today: 'Hari Ini',
        now: 'Sekarang'
      },
      selectedItems: {
        title: 'Item yang Dipilih'
      },
      actions: {
        edit: 'Edit',
        save: 'Simpan',
        cancel: 'Batal'
      }
    },
    editOperations: 'Edit Operasi',
    customs: {
      selectDocument: 'Pilih Dokumen Bea Cukai',
      selectDocumentDescription: 'Silakan pilih format dokumen bea cukai untuk dicetak.',
      bc27: 'BC 27',
      bc25: 'BC 25',
      bc41: 'BC 41',
      bc30: 'BC 30',
      noItemsSelected: 'Silakan pilih item untuk mencetak dokumen bea cukai.',
      loadingDocument: 'Mempersiapkan dokumen bea cukai...',
      bc27Title: 'BC 27 - Commercial Invoice & Packing List',
      documentNumber: 'Nomor Dokumen',
      outputFormat: 'Format Output',
      exchangeRate: 'Nilai Tukar',
      shipper: 'Shipper/Exportir',
      consignee: 'Consignee',
      notifyParty: 'Notify Party',
      invoiceNo: 'No. & Tanggal Invoice',
      lcNumber: 'No. & Tanggal L/C',
      remark: 'Remark',
      portOfLoading: 'Port of Loading',
      finalDestination: 'Final Destination',
      carrier: 'Carrier',
      sailingDate: 'Sailing on or about',
      marksNumber: 'Marks and Number of PKGS',
      itemCode: 'Kode Barang',
      hsCode: 'Kode HS',
      style: 'Style',
      description: 'Description of goods',
      netKg: 'Net Kg',
      qty: 'Qty',
      totalPrice: 'Total Price',
      rate: 'Kurs',
      package: 'kemasan',
      amount: 'Amount (Rp)',
      npwp16: 'NPWP 16',
      nitku: 'NITKU',
      npwpPlaceholder: '00.000.000.0-000.000',
      nitkuPlaceholder: '0000000000000000000000',
      addressPlaceholder: 'Alamat',
      cityPlaceholder: 'Kota',
      address1: 'Alamat 1',
      address2: 'Alamat 2',
      address1Placeholder: 'Alamat 1',
      address2Placeholder: 'Alamat 2',
      doubleClickToEdit: 'Klik dua kali untuk mengedit',
      vendorInfoWarning: 'Silakan periksa Alamat, NPWP, dan NITKU di Data Utama > Perusahaan > Pendaftaran Perusahaan.'
    }
  },

  dashboard: {
    activeOrders: 'Order Aktif',
    productionRate: 'Tingkat Produksi',
    pendingShipments: 'Pengiriman Tertunda',
    averageProcessTime: 'Waktu Proses',
    thisMonthOrders: 'Order Bulan Ini',
    lastMonthOrders: 'Order Bulan Lalu',
    thisMonthShipments: 'Pengiriman Bulan Ini',
    lastMonthShipments: 'Pengiriman Bulan Lalu',
    recentProduction: 'Produksi Terbaru',
    orderStatus: 'Status Order',
    inbound: 'Masuk',
    outbound: 'Keluar',
    vsLastWeek: 'vs Minggu Lalu',
    vsTarget: 'vs Target',
    vsYesterday: 'vs Kemarin',
    vsLastMonth: 'vs Bulan Lalu',
    vsLastYear: 'vs Tahun Lalu',
    currentMonth: 'Bulan Ini',
    date: 'Tanggal',
    noProductionData: 'Tidak ada data produksi',
    production: {
      winding: 'Winding',
      windingStatus: 'Status Produksi Winding',
      cheese: 'Cheese',
      batch: 'LOT',
      batch_s1: 'LOT 1S (06–14)',
      batch_s2: 'LOT 2S (14–22)',
      batch_s3: 'LOT 3S (22–06)',
      dyeing: 'Status Produksi Pencelupan',
      dyeingDayBasis: 'Hari operasi pencelupan: {{timezone}} dari jam {{hour}}:00'
    }
  },

  login: {
    welcome: 'Selamat Datang',
    username: 'Nama Pengguna',
    password: 'Kata Sandi',
    rememberMe: 'Ingat saya',
    forgotPassword: 'Lupa kata sandi?',
    login: 'Masuk',
    noAccount: 'Tidak punya akun?',
    signup: 'Daftar',
    loading: 'Masuk...',
    success: 'Berhasil masuk',
    validation: {
      required: 'Nama pengguna dan kata sandi wajib diisi.',
      usernameRequired: 'Silakan masukkan nama pengguna.',
      passwordRequired: 'Silakan masukkan kata sandi.'
    },
    error: {
      notFound: 'Akun tidak ditemukan.\nPeriksa nama pengguna.',
      invalidPassword: 'Kata sandi tidak valid.\nCoba lagi.',
      waitingApproval: 'Menunggu persetujuan.',
      blocked: 'Akun diblokir.\nHubungi admin.',
      network: 'Kesalahan jaringan.\nPeriksa koneksi.',
      unknown: 'Kesalahan tidak diketahui.\nCoba lagi.',
      userFetchFailed: 'Terjadi kesalahan saat mengambil informasi pengguna.',
      userUpdateFailed: 'Terjadi kesalahan saat memperbarui informasi pengguna.',
      languageUpdateFailed: 'Terjadi kesalahan saat memperbarui pengaturan bahasa.',
      logoutFailed: 'Terjadi kesalahan saat logout.'
    }
  },

  signup: {
    title: 'Daftar',
    department: 'Departemen',
    region: 'Wilayah',
    fullName: 'Nama Lengkap',
    userId: 'ID Pengguna',
    password: 'Kata Sandi',
    confirmPassword: 'Konfirmasi Kata Sandi',
    submit: 'Kirim',
    loading: 'Membuat akun...',
    cancel: 'Batal',
    submitting: 'Menyimpan...',
    fields: {
      userId: 'ID Pengguna',
      password: 'Kata Sandi',
      confirmPassword: 'Konfirmasi Kata Sandi',
      fullName: 'Nama Lengkap',
      department: 'Departemen',
      region: 'Wilayah',
      initialStr: 'Inisial',
      initialStrHelp: 'Huruf pertama nama Inggris Anda. Hanya satu atau dua huruf yang diperbolehkan.'
    },
    regions: {
      korea: 'Korea',
      vietnam: 'Vietnam',
      indonesia: 'Indonesia'
    },
    messages: {
      registerSuccess: 'Akun berhasil dibuat.\nMenunggu persetujuan admin.'
    },
    validation: {
      required: 'Bidang ini wajib diisi',
      fullName: {
        invalid: 'Hanya huruf dan spasi yang diperbolehkan'
      },
      userId: {
        tooShort: 'ID Pengguna harus minimal 6 karakter',
        invalid: 'ID Pengguna hanya dapat berisi huruf dan angka'
      },
      password: {
        tooShort: 'Kata Sandi harus minimal 6 karakter',
        invalid: 'Kata Sandi harus menyertakan huruf besar, huruf kecil, angka, dan karakter khusus'
      },
      passwordMismatch: 'Kata Sandi tidak cocok'
    },
    error: {
      duplicate: 'ID Pengguna sudah digunakan.\nSilakan coba yang lain.',
      network: 'Kesalahan jaringan terjadi.\nSilakan coba lagi.',
      unknown: 'Kesalahan tidak diketahui terjadi.\nSilakan coba lagi.',
      userIdExists: 'ID pengguna sudah ada.',
      initialStrExists: 'Inisial sudah ada.',
      passwordInvalid: 'Kata sandi tidak valid.',
      requiredFields: 'Silakan isi semua kolom wajib.',
      passwordMismatch: 'Kata sandi tidak cocok.',
      passwordLength: 'Kata sandi minimal 6 karakter.',
      userIdRequired: 'Silakan masukkan ID pengguna.',
      passwordRequired: 'Silakan masukkan kata sandi.',
      confirmPasswordRequired: 'Silakan konfirmasi kata sandi.',
      fullNameRequired: 'Silakan masukkan nama lengkap.',
      departmentRequired: 'Silakan pilih departemen.',
      regionRequired: 'Silakan pilih wilayah.',
      initialStrRequired: 'Silakan masukkan inisial.',
      server: 'Terjadi kesalahan server. Silakan coba lagi.'
    },
    departments: {
      marketing: 'Marketing',
      dyeing: 'Dyeing',
      production: 'Production',
      'qc/qa': 'QC/QA',
      admin: 'Admin'
    }
  },

  companies: {
    tabs: {
      company: 'Perusahaan',
      manager: 'Manajer',
      factory: 'Pabrik',
      map: 'Peta Pabrik'
    },
    companyInfo: 'Informasi Perusahaan',
    fields: {
      partner_code: 'Kode Perusahaan',
      companyName: 'Nama Perusahaan',
      businessNumber: 'Nomor Bisnis',
      representative: 'Perwakilan',
      businessType: 'Jenis Bisnis',
      businessCategory: 'Kategori Bisnis',
      postalCode: 'Kode Pos',
      baseAddress: 'Alamat Dasar',
      detailAddress: 'Alamat Detail',
      address: 'Alamat',
      extraInfo: 'Info Tambahan',
      extraInfoKey: 'Kunci',
      extraInfoValue: 'Nilai',
      addExtraInfo: 'Tambah Info Tambahan',
      created_at: 'Waktu Pendaftaran',
      created_by: 'Pendaftar',
      searchByNameOrCode: 'Cari berdasarkan kode atau nama perusahaan'
    },
    list: {
      title: 'Daftar Perusahaan'
    },
    search: 'Cari',
    addressSearch: 'Cari Alamat',
    searchPlaceholder: 'Cari berdasarkan nama perusahaan atau nomor bisnis',
    add: {
      title: 'Daftarkan Perusahaan',
      confirmMessage: 'Apakah Anda ingin mendaftarkan perusahaan baru?',
      success: 'Perusahaan berhasil didaftarkan.'
    },
    edit: {
      title: 'Edit Perusahaan',
      success: 'Informasi perusahaan telah diperbarui.',
      confirmMessage: 'Apakah Anda ingin memperbarui perusahaan ini?'
    },
    delete: {
      title: 'Hapus Perusahaan',
      confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
    },
    changes: {
      before: 'Sebelum',
      after: 'Setelah'
    },
    search: 'Pencarian Customer',
    fields: {
      partner_code: 'Kode Partner',
      companyName: 'Nama Perusahaan',
      businessNumber: 'Nomor Bisnis',
      ceoName: 'Nama CEO',
      searchByPartnerCodeOrCompanyName: 'Cari berdasarkan Kode Partner atau Nama Perusahaan'
    }
  },

  buyers: {
    title: 'Manajemen Buyer',
    form: {
      title: 'Informasi Buyer'
    },
    list: {
      title: 'Daftar Buyer'
    },
    fields: {
      buyerCode: 'Kode Buyer',
      buyerName: 'Nama Buyer',
      buyerGroup: 'Grup',
      category: 'Kategori',
      remark: 'Remark'
    },
    validation: {
      required: 'Bidang ini wajib diisi',
      duplicateCategoryBuyer: 'Buyer dengan kategori dan nama yang sama sudah ada'
    },
    add: {
      title: 'Daftarkan Buyer',
      confirmMessage: 'Apakah Anda ingin mendaftarkan buyer baru?',
      success: 'Buyer berhasil didaftarkan.'
    },
    edit: {
      title: 'Edit Buyer',
      confirmMessage: 'Apakah Anda ingin memperbarui buyer ini?',
      success: 'Buyer berhasil diperbarui.'
    },
    delete: {
      title: 'Hapus Buyer',
      confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
    },
    searchPlaceholder: 'Cari berdasarkan kode buyer atau nama buyer',
    error: {
      duplicateCategoryBuyer: 'Buyer dengan kategori dan nama yang sama sudah ada'
    }
  },

  managers: {
    form: {
      title: 'Informasi Manajer'
    },
    fields: {
      name: 'Nama',
      partnerId: 'Perusahaan',
      telephone: 'Telepon',
      mobile: 'Ponsel',
      fax: 'Faks',
      email: 'Email',
      partnerName: 'Nama Perusahaan'
    },
    list: {
      title: 'Daftar Manajer'
    },
    add: {
      title: 'Daftarkan Manajer',
      confirmMessage: 'Apakah Anda ingin mendaftarkan manajer baru?',
      success: 'Manajer berhasil didaftarkan.'
    },
    edit: {
      title: 'Edit Manajer',
      success: 'Informasi manajer telah diperbarui.',
      confirmMessage: 'Apakah Anda ingin memperbarui manajer ini?'
    },
    delete: {
      title: 'Hapus Manajer',
      confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
    },
    searchPlaceholder: 'Cari berdasarkan nama manajer atau nama perusahaan',
    validation: {
      selectCompany: 'Silakan pilih perusahaan'
    },
    error: {
      title: "Kesalahan",
      save: "Gagal menyimpan.",
      duplicateManager: "Nama manajer sudah ada untuk perusahaan ini."
    }
  },

  factories: {
    form: {
      title: 'Informasi Pabrik'
    },
    list: {
      title: 'Daftar Pabrik'
    },
    fields: {
      partner: 'Perusahaan',
      name: 'Nama Pabrik',
      shippingMark: 'Tanda Pengiriman',
      region: 'Wilayah',
      address: 'Alamat',
      address1: 'Alamat 1',
      address2: 'Alamat 2',
      city: 'Kota',
      state: 'Provinsi',
      postcode: 'Kode Pos',
      country: 'Negara',
      countryCode: 'Kode Negara',
      taxId: 'NPWP',
      customsId: 'NITKU',
      extraInfo: 'Info Tambahan',
      extraInfoKey: 'Kunci',
      extraInfoValue: 'Nilai',
      addPartner: 'Tambah Perusahaan',
      addExtraInfo: 'Tambah Info Tambahan'
    },
    validation: {
      selectCompany: 'Silakan pilih perusahaan',
      required: 'Bidang ini wajib diisi'
    },
    add: {
      title: 'Daftarkan Pabrik',
      confirmMessage: 'Apakah Anda ingin mendaftarkan pabrik baru?',
      success: 'Pabrik berhasil didaftarkan.'
    },
    edit: {
      title: 'Edit Pabrik',
      confirmMessage: 'Apakah Anda ingin memperbarui pabrik ini?',
      success: 'Pabrik berhasil diperbarui.'
    },
    delete: {
      title: 'Hapus Pabrik',
      confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
    },
    searchPlaceholder: 'Cari berdasarkan nama perusahaan atau pabrik'
  },

  admin: {
    registration: {
      list: 'Daftar Pendaftaran',
      userId: 'ID Pengguna',
      name: 'Nama',
      department: 'Departemen',
      region: 'Wilayah',
      date: 'Tanggal',
      actions: 'Actions',
      status: {
        pending: 'Tertunda',
        approved: 'Disetujui',
        rejected: 'Ditolak',
        all: 'Semua Status'
      },
      approve: 'Setujui',
      reject: 'Tolak',
      add: 'Tambah',
      addNew: 'Tambah Baru',
      addSuccess: 'Pengguna berhasil ditambahkan.',
      allDepartments: 'Semua Departemen',
      status_name: 'Status',
      approveSuccess: 'Pendaftaran telah disetujui.',
      approveFailed: 'Persetujuan pendaftaran gagal.',
      rejectSuccess: 'Pendaftaran telah ditolak.',
      rejectFailed: 'Penolakan pendaftaran gagal.'
    },
    passwordReset: {
      list: 'Daftar Reset Kata Sandi',
      userId: 'ID Pengguna',
      name: 'Nama',
      department: 'Departemen',
      region: 'Wilayah',
      lastReset: 'Reset Terakhir',
      resetButton: 'Reset Kata Sandi',
      confirmReset: 'Apakah Anda yakin ingin mereset kata sandi?',
      action: 'Action'
    },
    accessLogs: {
      list: 'Log Akses',
      userId: 'ID Pengguna',
      name: 'Nama',
      department: 'Departemen',
      accessTime: 'Waktu Akses',
      ipAddress: 'Alamat IP',
      action: 'Action',
      status: 'Status',
      startDate: 'Tanggal Mulai',
      endDate: 'Tanggal Akhir',
      allDepartments: 'Semua Departemen',
      departments: {
        all: 'Semua Departemen',
        production: 'Produksi',
        marketing: 'Pemasaran',
        admin: 'Admin'
      },
      actions: {
        login: 'Masuk',
        logout: 'Keluar',
        all: 'Semua Tindakan'
      },
      status: {
        name: 'Status',
        success: 'Berhasil',
        failed: 'Gagal'
      },
      region: 'Wilayah',
    },
    message: {
      title: 'Judul Pesan',
      content: 'Konten Pesan',
      send: 'Kirim Pesan',
      selectedUsers: 'Pengguna Terpilih',
      user: 'Pengguna',
      selectUsers: 'Pilih Pengguna',
      department: 'Departemen',
      region: 'Wilayah',
      allDepartments: 'Semua Departemen',
      departments: {
        production: 'Produksi',
        marketing: 'Pemasaran',
        admin: 'Admin'
      }
    },
    threads: {
      tabs: {
        item: 'Pendaftaran Item',
        weight: 'Pendaftaran Berat'
      },
      list: {
        title: 'Daftar Item'
      },
      form: {
        title: 'Informasi Item'
      },
      edit: {
        title: 'Edit Item',
        confirmMessage: 'Apakah Anda ingin memperbarui item ini?',
        success: 'Item berhasil diperbarui.'
      },
      fields: {
        threadName: 'Nama Item',
        specification: 'Jenis Benang',
        division: 'Divisi',
        yarn_type: 'Jenis Benang',
        tex: 'TEX',
        ne: 'NE',
        denier: 'DENIER',
        thread_luster_type: 'Tipe Kilau Benang',
        threadLusterType: 'Tipe Kilau Benang',
        recycleCode: 'Kode Ramah Lingkungan',
        weight: 'Berat',
        unit: 'Satuan'
      },
      searchPlaceholder: 'Cari berdasarkan nama item',
      validation: {
        required: 'Bidang ini wajib diisi',
        invalidNumber: 'Masukkan angka yang valid',
        duplicateSpecification: 'Spesifikasi item sudah ada',
        duplicateThread: 'Item dengan nama dan spesifikasi yang sama sudah ada',
        unit: 'Silakan masukkan satuan',
        selectItem: 'Silakan pilih item'
      },
      add: {
        title: 'Daftarkan Item',
        confirmMessage: 'Apakah Anda ingin mendaftarkan item baru?',
        success: 'Item berhasil didaftarkan.'
      },
      delete: {
        title: 'Hapus Item',
        confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
      }
    },
    prices: {
      list: {
        title: 'Daftar Harga',
        totalCount: 'Total item harga : {{count}}'
      },
      columns: {
        no: 'NO',
        customer: 'CUSTOMER',
        item: 'ITEM',
        size: 'SIZE',
        currency: 'CURRENCY',
        price: 'PRICE',
        spec: 'SPEC',
        regDate: 'REG DATE',
        action: 'ACTION'
      },
      picker: {
        title: 'Pilih hasil',
        type: 'TIPE',
        name: 'NAMA',
        customer: 'CUSTOMER',
        item: 'ITEM'
      },
      form: {
        title: 'Informasi Harga'
      },
      fields: {
        companyName: 'Perusahaan',
        itemName: 'Item',
        size: 'Ukuran(M)',
        currency: 'Mata Uang',
        price: 'Harga',
        searchByNameOrCode: 'Cari berdasarkan nama perusahaan atau item',
        duplicate: 'Harga ini sudah terdaftar.'
      },
      validation: {
        required: 'Bidang ini wajib diisi'
      },
      add: {
        title: 'Daftarkan Harga',
        confirmMessage: 'Apakah Anda ingin mendaftarkan harga baru?',
        success: 'Harga berhasil didaftarkan.'
      },
      edit: {
        title: 'Edit Harga',
        confirmMessage: 'Apakah Anda ingin memperbarui harga ini?',
        success: 'Harga berhasil diperbarui.'
      },
      delete: {
        title: 'Hapus Harga',
        confirmMessage: 'Apakah Anda yakin ingin menghapus harga ini?'
      },
      searchPlaceholder: 'Cari berdasarkan nama perusahaan atau item'
    },
    sizes: {
      list: {
        title: 'Daftar Ukuran'
      },
      form: {
        title: 'Informasi Ukuran'
      },
      fields: {
        size: 'Ukuran(M)'
      },
      validation: {
        required: 'Bidang ini wajib diisi',
        invalidNumber: 'Masukkan angka yang valid',
        duplicate: 'Ukuran ini sudah ada.',
        selectSize: 'Silakan pilih ukuran'
      },
      add: {
        title: 'Daftarkan Ukuran',
        confirmMessage: 'Apakah Anda ingin mendaftarkan ukuran baru?',
        success: 'Ukuran berhasil didaftarkan.'
      },
      edit: {
        title: 'Edit Ukuran',
        confirmMessage: 'Apakah Anda ingin memperbarui ukuran ini?',
        success: 'Ukuran berhasil diperbarui.'
      },
      delete: {
        title: 'Hapus Ukuran',
        confirmMessage: 'Apakah Anda yakin ingin menghapus ukuran ini?'
      },
      searchPlaceholder: 'Cari berdasarkan ukuran',
      search: 'Cari Ukuran'
    },
    weights: {
      list: {
        title: 'Daftar Berat'
      },
      form: {
        title: 'Informasi Berat'
      },
      fields: {
        threadName: 'Nama Item',
        size: 'Ukuran(M)',
        netWeight: 'Berat Bersih (N/W)',
        grossWeight: 'Berat Kotor (G/W)',
        ctQuantity: 'Jumlah (C/T)',
        remark: 'Remark'
      },
      validation: {
        required: 'Bidang ini wajib diisi',
        invalidNumber: 'Masukkan angka yang valid',
        duplicate: 'Konfigurasi berat ini sudah ada.'
      },
      add: {
        title: 'Daftarkan Berat',
        confirmMessage: 'Apakah Anda ingin mendaftarkan berat baru?',
        success: 'Berat berhasil didaftarkan.'
      },
      edit: {
        title: 'Edit Berat',
        confirmMessage: 'Apakah Anda ingin memperbarui berat ini?',
        success: 'Berat berhasil diperbarui.'
      },
      delete: {
        title: 'Hapus Berat',
        confirmMessage: 'Apakah Anda yakin ingin menghapus berat ini?'
      },
      searchPlaceholder: 'Cari berdasarkan nama item',
      search: 'Cari Berat'
    },
    yarn: {
      list: 'Daftar Benang',
      code: 'Kode Benang',
      type: 'Tipe',
      count: 'Hitungan',
      twist: 'Pilinan',
      supplier: 'Pemasok',
      lotNumber: 'Nomor Lot',
      quantity: 'Quantity',
      location: 'Lokasi',
      status: {
        inStock: 'Tersedia',
        lowStock: 'Stok Rendah',
        outOfStock: 'Habis',
        all: 'Semua Status'
      },
      add: 'Tambah Benang',
      addNew: 'Tambah Benang Baru',
      allTypes: 'Semua Tipe',
      type: {
        cotton: 'Katun',
        polyester: 'Polyester',
        blend: 'Campuran'
      },
      location: {
        warehouseA: 'Gudang A',
        warehouseB: 'Gudang B',
        production: 'Produksi'
      },
      showHistory: 'Tampilkan Riwayat',
      history: 'Riwayat Pergerakan'
    },
    dye: {
      list: 'Daftar Dye',
      code: 'Kode Dye',
      name: 'Nama Dye',
      type: 'Tipe',
      manufacturer: 'Produsen',
      color: 'Warna',
      lotNumber: 'Nomor Lot',
      quantity: 'Quantity',
      location: 'Lokasi',
      expiryDate: 'Tanggal Kedaluwarsa',
      status: {
        inStock: 'Tersedia',
        lowStock: 'Stok Rendah',
        outOfStock: 'Habis',
        expired: 'Kedaluwarsa',
        nearExpiry: 'Hampir Kedaluwarsa',
        all: 'Semua Status'
      },
      add: 'Tambah Dye',
      addNew: 'Tambah Dye Baru',
      allTypes: 'Semua Tipe',
      type: {
        reactive: 'Reaktif',
        disperse: 'Dispersi',
        acid: 'Asam'
      },
      color: {
        blue: 'Biru',
        red: 'Merah',
        yellow: 'Kuning'
      },
      location: {
        storageA: 'Penyimpanan A',
        storageB: 'Penyimpanan B',
        production: 'Produksi'
      },
      showHistory: 'Tampilkan Riwayat',
      history: 'Riwayat Pergerakan',
      expiredWarning: 'Item ini telah kedaluwarsa',
      sampleName: 'Sampel Dye'
    },
    inventory: {
      list: 'Daftar Inventaris',
      code: 'Kode Item',
      name: 'Nama Item',
      type: 'Tipe',
      category: 'Kategori',
      quantity: 'Quantity',
      location: 'Lokasi',
      minStock: 'Stok Min',
      maxStock: 'Stok Maks',
      lastMovement: 'Pergerakan Terakhir',
      stockRange: 'Rentang Stok',
      status: {
        inStock: 'Tersedia',
        lowStock: 'Stok Rendah',
        overStock: 'Kelebihan Stok',
        all: 'Semua Status'
      },
      add: 'Tambah Inventaris',
      addNew: 'Tambah Inventaris Baru',
      allTypes: 'Semua Tipe',
      allLocations: 'Semua Lokasi',
      type: {
        yarn: 'Benang',
        dye: 'DYEING',
        chemical: 'CHEMICAL',
        packaging: 'Pengemasan'
      },
      category: {
        rawMaterial: 'Bahan Mentah',
        finishedGood: 'Barang Jadi',
        packaging: 'Pengemasan'
      },
      location: {
        warehouseA: 'Gudang A',
        warehouseB: 'Gudang B',
        production: 'Produksi'
      },
      recordMovement: 'Catat Pergerakan',
      sampleItem: 'Sampel Item'
    },
    bi: {
      title: 'BI',
      startDate: 'Start Date',
      endDate: 'End Date',
      customer: 'CUSTOMER',
      manager: 'Kontak',
      buyer: 'BUYER',
      search: 'Search',
      loading: 'Please wait...',
      orderDate: 'Order Date',
      vendorName: 'Company',
      itemName: 'Item',
      size: 'Size',
      color: 'Color',
      qty: 'QTY',
      price: 'Unit Price',
      amount: 'Amount',
      total: 'TOTAL',
      itemAggregationTitle: 'Agregasi Item per Periode',
      noData: 'No data found',
      searchGuide: 'Please search to view data',
      error: 'Kesalahan',
      dateError: 'Tanggal akhir tidak boleh lebih awal dari tanggal mulai.'
    }
  },

  error: {
    fetch: 'Gagal mengambil data',
    network: 'Terjadi kesalahan jaringan',
    unknown: 'Terjadi kesalahan tidak diketahui',
    title: 'Kesalahan',
    duplicate: 'Perusahaan sudah ada',
    duplicateFactory: 'Pabrik sudah ada',
    duplicateManager: 'Manajer sudah ada',
    duplicateDivisionSeason: 'Buyer dengan divisi dan musim yang sama sudah ada',
    save: 'Gagal menyimpan data',
    unauthorized: 'Token login telah kedaluwarsa.\nSilakan masuk kembali.',
    noChanges: 'Tidak ada perubahan untuk diperbarui',
    sessionExpired: 'Sesi Anda telah berakhir. Silakan masuk kembali.'
  },

  initialStr: {
    label: 'Kode Dyeing Unik',
    placeholder: 'Masukkan 1-2 karakter (a-z, A-Z)',
    required: 'Kode Dyeing unik diperlukan',
    invalid: 'Hanya 1-2 karakter bahasa Inggris yang diperbolehkan',
    alreadyExists: 'Kode unik ini sudah digunakan',
    validationFailed: 'Gagal memvalidasi kode unik',
    notVerified: 'Silakan verifikasi keunikan kode Dyeing',
    verifying: 'Memverifikasi kode unik...'
  },

  validation: {
    required: 'Bidang ini wajib diisi',
    selectCompany: 'Silakan pilih perusahaan'
  },
  userInfoDialog: {
    title: 'Informasi Pengguna',
    basicInfo: 'Informasi Dasar',
    id: 'ID (Bacaan Hanya)',
    name: 'Nama',
    department: 'Departemen (Bacaan Hanya)',
    region: 'Wilayah',
    password: 'Kata Sandi',
    editableInfo: 'Informasi yang Dapat Diubah',
    passwordChange: 'Ubah Kata Sandi',
    newPassword: 'Kata Sandi Baru',
    confirmNewPassword: 'Konfirmasi Kata Sandi Baru',
    currentPassword: 'Kata Sandi Saat Ini',
    confirmCurrentPassword: 'Konfirmasi Kata Sandi Saat Ini',
    passwordError: 'Kata Sandi tidak cocok',
    passwordSuccess: 'Kata Sandi berhasil diubah',
  },

  invoice: {
    title: 'Penerbitan Invoice',
    selectedItems: 'Item Terpilih',
    issueButton: 'Terbitkan Invoice',
    debitNoteButton: 'Terbitkan DEBIT NOTE',
    debitNote: {
      errorTitle: 'Tidak Dapat Diterbitkan',
      differentCustomers: 'Harap pilih hanya dari Customer yang sama',
      currentlySelectedCustomers: 'Customer yang saat ini dipilih',
      missingPacking: 'Harap pilih hanya item yang sudah dikirim.',
      itemsWithoutPackingDate: 'Item tanpa tanggal PACKING'
    },
    hideInvoicedToggle: {
      tooltipOff: 'Tampilkan semua baris',
      tooltipOn:
        'Sembunyikan yang sudah terbit penuh; jumlah qty invoice masih di bawah order qty tetap tampil'
    },
    warning: 'Peringatan',
    selectItems: 'Silakan pilih item untuk diterbitkan',
    differentVendors: 'Item yang dipilih memiliki vendor yang berbeda. Silakan pilih item dari vendor yang sama.',
    differentCurrencies: 'Item yang dipilih memiliki mata uang yang berbeda. Silakan pilih item dengan mata uang yang sama.',
    existingInvoiceWarning: '{{existingCount}}/{{totalCount}} item yang dipilih sudah memiliki invoice yang diterbitkan. Apakah Anda ingin melanjutkan?',
    success: 'Berhasil',
    issuanceSuccess: 'Invoice berhasil diterbitkan',
    partialIssuanceSuccess: 'invoice berhasil diterbitkan',
    issuanceError: 'Gagal menerbitkan invoice',
    startDate: 'Tanggal Mulai',
    endDate: 'Tanggal Akhir',
    customerName: 'Nama Customer',
    managerName: 'Nama Manajer',
    invoiceNo: 'No Invoice',
    invoiceDate: 'Tanggal Invoice',
    dueDate: 'Tanggal Jatuh Tempo',
    currency: 'Mata Uang',
    amount: 'Amount',
    vatAmount: 'VAT',
    vatAmount2: 'VAT(BC45)',
    totalAmount: 'Total Jumlah',
    status: 'Status',
    updateStatus: 'Perbarui Status',
    statusUpdateTitle: 'Perbarui Status Invoice',
    newStatus: 'Status Baru',
    selectedInvoices: 'Invoice Terpilih ({{count}})',
    noData: 'Tidak ada data ditemukan',
    error: {
      startDateRequired: 'Tanggal mulai diperlukan',
      selectItemsForStatusUpdate: 'Silakan pilih item untuk memperbarui status',
      selectItemsForPrint: 'Silakan pilih invoice untuk dicetak',
      statusUpdateFailed: 'Gagal memperbarui status',
      noDataToExport: 'Tidak ada data untuk diekspor',
      exportFailed: 'Ekspor gagal',
      noItemSelected: 'Tidak ada item yang dipilih'
    },
    print: {
      title: 'Cetak Invoice',
      preview: 'Pratinjau Invoice',
      columnSettings: 'Pengaturan Kolom Cetak'
    },
    itemDetails: 'Detail Item',
    bankInfo: 'Informasi Bank',
    success: {
      statusUpdate: '{{success}} status invoice berhasil diperbarui. (Gagal: {{fail}})',
      exportCompleted: 'Data berhasil diekspor'
    },
    statusOptions: {
      issued: 'Diterbitkan',
      pending: 'Tertunda',
      cancelled: 'Dibatalkan',
      paid: 'Dibayar',
      partial_paid: 'Dibayar Sebagian',
      partial: 'Dibayar Sebagian',
      canceled: 'Dibatalkan',
      completed: 'Selesai',
      overdue: 'Terlambat',
      canceled: 'Dibatalkan',
      unpaid: 'Belum Dibayar'
    },
    vat: {
      taxFree: 'Bebas Pajak',
      BC21: 'BC21',
      BC45: 'BC45'
    },
    columns: {
      no: 'NO',
      giReqNo: 'GI REQ NO',
      giReqLineId: 'GI REQ LINE ID',
      customer: 'CUSTOMER',
      subOrderId: 'SubOrderID',
      buyer: 'BUYER',
      style: 'STYLE',
      file: 'FILE',
      delivery: 'DELIVERY',
      manager: 'MANAGER',
      item: 'ITEM',
      size: 'SIZE',
      dyeingNo: 'DYEING NO',
      orderQty: 'ORDER QTY',
      giReq: 'GI REQ',
      packing: 'PACKING',
      giPost: 'GI POST',
      priceSum: 'PRICE SUM',
      invoiceNoCol: 'INVOICE NO',
      status: 'STATUS',
      currency: 'CURRENCY',
      mainOrderId: 'ID Order Utama',
      orderReceivedDate: 'Tanggal Order Diterima',
      deliveryDate: 'Tanggal Pengiriman',
      vendorName: 'Nama Vendor',
      managerName: 'Nama Manajer',
      threadName: 'Nama Benang',
      sizeName: 'Ukuran',
      color: 'COLOR',
      giHistory: 'DELIVERY DATE',
      qtyDelivered: 'Jumlah Dikirim',
      price: 'PRICE',
      priceCurrency: 'Mata Uang',
      amount: 'Amount',
      existingInvoiceNo: 'No Invoice yang Ada',
      existingInvoiceStatus: 'Status Invoice yang Ada',
      payment: 'Pembayaran',
      paymentStatus: 'Status Pembayaran',
      styleNo: 'No Style',
      fileNo: 'No File',
      factory: 'Pabrik',
      sign: 'Tanda Tangan'
    },
    fields: {
      searchConditions: 'Kondisi Pencarian',
      deliveryId: 'DELIVERY ID'
    },
    dialog: {
      title: 'Konfirmasi Penerbitan Invoice',
      description: 'Apakah Anda yakin ingin menerbitkan invoice untuk item yang dipilih?',
      selectedCount: 'Item Terpilih',
      totalAmount: 'TOTAL',
      totalQuantity: 'QTY TOTAL',
      vendorName: 'Nama Vendor',
      summary: 'Ringkasan',
      itemCount: 'Jumlah Item',
      currencyAmount: 'TOTAL',
      details: 'Detail',
      invoiceGroup: 'Grup Invoice',
      vatSelection: 'Pilihan VAT',
      vatType: 'Jenis VAT',
      warning: 'Invoice tidak dapat diubah setelah diterbitkan. Silakan periksa dengan teliti.',
      confirm: 'Konfirmasi Penerbitan',
      bulkApplyDeliveryDate: 'Terapkan ke baris terpilih',
      confirmTitle: 'Konfirmasi Penerbitan Invoice',
      confirmMessage: 'Invoice yang sudah diterbitkan tidak dapat dibatalkan.\nApakah Anda ingin melanjutkan?',
      confirmYes: 'Ya',
      confirmNo: 'Tidak'
    },
    row: {
      issued: 'Diterbitkan'
    }
  },
  master: {
    machine: {
      list: {
        title: 'Daftar Mesin'
      },
      form: {
        title: 'Informasi Mesin'
      },
      fields: {
        machineNo: 'No. Mesin',
        machineName: 'Nama Mesin',
        category: 'Kategori',
        manufacturedDate: 'Tanggal Produksi',
        installedDate: 'Tanggal Pemasangan',
        manufacturer: 'Pabrikan',
        price: 'Harga',
        currency: 'Mata Uang',
        polyMin: 'Poly Min',
        polyMax: 'Poly Maks',
        nylonMin: 'Nylon Min',
        nylonMax: 'Nylon Maks',
        cheeseRange: 'Jumlah Cheese (P/N)',
        yarnType: 'Benang Khusus',
        remark: 'Remark',
        isActive: 'Aktif'
      },
      yarnType: {
        poly: 'Khusus Poly',
        nylon: 'Khusus Nylon',
        common: 'Umum'
      },
      active: 'Aktif',
      inactive: 'Nonaktif',
      add: {
        title: 'Daftarkan Mesin',
        confirmMessage: 'Daftarkan informasi mesin yang dimasukkan?',
        success: 'Mesin telah didaftarkan.'
      },
      edit: {
        title: 'Ubah Mesin',
        confirmMessage: 'Perbarui informasi mesin?',
        success: 'Informasi mesin telah diperbarui.'
      },
      delete: {
        title: 'Hapus Mesin',
        confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
      },
      validation: {
        price: 'Masukkan angka hingga 2 desimal.',
        polyMinMax: 'Poly maks harus lebih besar atau sama dengan min.',
        nylonMinMax: 'Nylon maks harus lebih besar atau sama dengan min.'
      },
      error: {
        duplicateMachineNo: 'Nomor mesin sudah ada.',
        invalidCurrency: 'Mata uang tidak valid.',
        invalidYarnType: 'Jenis benang khusus tidak valid.',
        minMax: 'Jumlah maks harus lebih besar atau sama dengan jumlah min.'
      },
      searchPlaceholder: 'Cari berdasarkan no./nama/pabrikan mesin'
    },
    uom: {
      tabs: {
        registration: 'Pendaftaran UOM',
        conversion: 'Pendaftaran Konversi UOM'
      },
      list: {
        title: 'Daftar UOM'
      },
      form: {
        title: 'Informasi UOM'
      },
      edit: {
        title: 'Edit UOM',
        confirmMessage: 'Apakah Anda ingin memperbarui UOM ini?',
        success: 'UOM berhasil diperbarui.'
      },
      fields: {
        code: 'Kode',
        name: 'Nama'
      },
      searchPlaceholder: 'Cari berdasarkan kode atau nama',
      validation: {
        required: 'Bidang ini wajib diisi',
        duplicateUom: 'Kode UOM sudah ada'
      },
      add: {
        title: 'Daftarkan UOM',
        confirmMessage: 'Apakah Anda ingin mendaftarkan UOM baru?',
        success: 'UOM berhasil didaftarkan.'
      },
      delete: {
        title: 'Hapus UOM',
        confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
      },
      conversion: {
        title: 'Pendaftaran Konversi UOM',
        list: {
          title: 'Daftar Konversi UOM'
        },
        form: {
          title: 'Informasi Konversi UOM'
        },
        fields: {
          fromUom: 'Dari UOM',
          toUom: 'Ke UOM',
          factor: 'Faktor Konversi'
        },
        searchPlaceholder: 'Cari berdasarkan kode UOM, nama atau faktor',
        validation: {
          required: 'Bidang ini wajib diisi',
          sameUom: 'Dari UOM dan Ke UOM tidak boleh sama',
          duplicateConversion: 'Konversi ini sudah ada',
          invalidFactor: 'Silakan masukkan faktor konversi yang valid'
        },
        add: {
          title: 'Daftarkan Konversi UOM',
          confirmMessage: 'Apakah Anda ingin mendaftarkan konversi UOM baru?',
          success: 'Konversi UOM berhasil didaftarkan.'
        },
        delete: {
          title: 'Hapus Konversi UOM',
          confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
        }
      }
    },
    location: {
      list: {
        title: 'Daftar Lokasi'
      },
      form: {
        title: 'Informasi Lokasi'
      },
      edit: {
        title: 'Edit Lokasi',
        confirmMessage: 'Apakah Anda ingin memperbarui lokasi ini?',
        success: 'Lokasi berhasil diperbarui.'
      },
      fields: {
        siteCode: 'Kode Situs',
        warehouse: 'Gudang',
        binCode: 'Kode Bin',
        type: 'Jenis',
        isActive: 'Aktif'
      },
      types: {
        warehouse: 'Gudang',
        site: 'Situs',
        bin: 'Bin'
      },
      searchPlaceholder: 'Cari berdasarkan kode situs, gudang, kode bin atau jenis',
      validation: {
        required: 'Bidang ini wajib diisi',
        duplicateLocation: 'Lokasi ini sudah ada'
      },
      add: {
        title: 'Daftarkan Lokasi',
        confirmMessage: 'Apakah Anda ingin mendaftarkan lokasi baru?',
        success: 'Lokasi berhasil didaftarkan.'
      },
      delete: {
        title: 'Hapus Lokasi',
        confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
      },
      downloadLayout: 'Tata Letak Gudang'
    },
    supplier: {
      list: {
        title: 'Daftar Pemasok'
      },
      form: {
        title: 'Informasi Pemasok'
      },
      edit: {
        title: 'Edit Pemasok',
        confirmMessage: 'Apakah Anda ingin memperbarui pemasok ini?',
        success: 'Pemasok berhasil diperbarui.'
      },
      fields: {
        partnerName: 'Nama Pemasok',
        partnerGroup: 'Grup Pemasok',
        specification: 'Remarks',
        bizRegNo: 'Nomor Registrasi Bisnis',
        postcode: 'Kode Pos',
        address1: 'Alamat 1',
        address2: 'Alamat 2',
        region: 'Wilayah'
      },
      groups: {
        supplier: 'Pemasok'
      },
      regions: {
        korea: 'Korea',
        indonesia: 'Indonesia',
        china: 'China',
        usa: 'USA',
        other: 'Lainnya'
      },
      searchPlaceholder: 'Cari berdasarkan nama pemasok, keterangan, nomor registrasi bisnis atau alamat',
      validation: {
        required: 'Bidang ini wajib diisi',
        duplicateSupplier: 'Pemasok ini sudah ada'
      },
      add: {
        title: 'Daftarkan Pemasok',
        confirmMessage: 'Apakah Anda ingin mendaftarkan pemasok baru?',
        success: 'Pemasok berhasil didaftarkan.'
      },
      delete: {
        title: 'Hapus Pemasok',
        confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
      }
    },
    itemTaxon: {
      title: 'Klasifikasi Item',
      selectCategory: 'Pilih Kategori',
      noData: 'Tidak ada data untuk ditampilkan',
      hasAttributes: 'Memiliki atribut',
      attributes: 'Atribut',
      levels: {
        category: 'Kategori',
        type: 'Tipe',
        spec: 'Spesifikasi'
      }
    },
    item: {
      fields: {
        sku: 'SKU',
        name: 'Nama Item',
        category: 'Kategori',
        baseUom: 'UOM Dasar',
        type: 'Tipe',
        spec: 'Spesifikasi',
        isDutyFree: 'Bebas Pajak',
        hsCode: 'Kode HS',
        attributes: 'Atribut'
      },
      selectCategory: 'Pilih Kategori',
      name: 'Nama Item',
      attributes: {
        keyPlaceholder: 'Kunci',
        valuePlaceholder: 'Nilai',
        add: 'Tambah Atribut'
      },
      list: {
        title: 'Informasi Item'
      },
      form: {
        title: 'Daftarkan Item'
      },
      add: {
        title: 'Daftarkan Item',
        confirmMessage: 'Apakah Anda ingin mendaftarkan item baru?',
        success: 'Item berhasil didaftarkan.'
      },
      edit: {
        title: 'Edit Item',
        confirmMessage: 'Apakah Anda ingin memperbarui informasi item?',
        success: 'Informasi item telah diperbarui.'
      },
      delete: {
        title: 'Hapus Item',
        confirmMessage: 'Apakah Anda yakin ingin menghapus {{name}}?'
      },
      validation: {
        required: 'Harap isi semua bidang yang wajib diisi.',
        duplicateItem: 'Item sudah ada.',
        invalidJson: 'Format JSON tidak valid.'
      },
      searchPlaceholder: 'Cari berdasarkan SKU, nama, kategori, tipe, spesifikasi, UOM, kode HS'
    }
  },

  windingDataPopup: {
    title: 'Manajemen Pengiriman',
    basicInfo: 'Informasi Dasar',
    shippingInfo: 'Informasi Pengiriman',
    remarksAndNotes: 'Catatan dan Memo',
    windingId: 'ID Winding',
    shippingTargetDate: 'Tanggal Target Pengiriman',
    truckName: 'Nama Truk',
    numberOfBox: 'Jumlah Kotak',
    timeOfDeparture: 'Waktu Keberangkatan',
    timeOfArrival: 'Waktu Kedatangan',
    remarkForShipping: 'Catatan Pengiriman',
    remark: 'Catatan Umum',
    factory: 'Pabrik',
    loading: 'Memuat data...',
    error: 'Terjadi Kesalahan',
    retry: 'Coba Lagi',
    close: 'Tutup',
    refresh: 'Segarkan',
    noData: 'Tidak ada data',
    networkError: 'Terjadi kesalahan jaringan. Periksa koneksi internet Anda.',
    serverError: 'Terjadi kesalahan server. Silakan coba lagi nanti.',
    notFound: 'Data untuk Winding ID {{id}} tidak ditemukan.',
    timeoutError: 'Permintaan habis waktu. Periksa status jaringan Anda.',
    fetchFailed: 'Gagal memuat data.',
    apiError: 'Terjadi kesalahan selama permintaan API. ({{status}})',
    unknownError: 'Terjadi kesalahan yang tidak diketahui.',
    arrived: 'Tiba',
    depart: 'Berangkat',
    completed: 'Selesai',
    updating: 'Memperbarui...',
    updateFailed: 'Gagal memperbarui.'
  },

  map: {
    controls: {
      title: 'Peta Pabrik',
      searchPlaceholder: 'Cari berdasarkan nama pabrik, wilayah, alamat...',
      factories: 'Daftar Pabrik',
      selectedFactory: 'Pabrik Terpilih',
      region: 'Wilayah',
      address: 'Alamat',
      shippingMark: 'Tanda Pengiriman',
      selected: 'Terpilih',
      noSearchResults: 'Tidak ada hasil pencarian.',
      noFactories: 'Tidak ada pabrik tersedia.',
      zoomIn: 'Perbesar',
      zoomOut: 'Perkecil',
      resetView: 'Reset Tampilan'
    },
    error: {
      fetchFailed: 'Gagal memuat data pabrik.',
      apiLoadFailed: 'Gagal memuat Google Maps API.',
      apiKeyRequired: 'Kunci API Google Maps diperlukan. Silakan setel variabel lingkungan REACT_APP_GOOGLE_MAPS_API_KEY.'
    }
  },
  inventory: {
    balance: {
      columns: {
        category: 'Kategori',
        type: 'Tipe',
        sku: 'SKU',
        name: 'Item',
        location: 'Lokasi',
        qty: 'Quantity',
        uom: 'Satuan',
        note: 'Note',
        report: 'Laporan'
      },
      report: {
        title: 'Laporan Tren Persediaan',
        graphButton: 'Grafik',
        period: 'Periode: {{start}} ~ {{end}}',
        itemIdLabel: 'Item ID: {{id}}',
        locationLabel: 'Lokasi: {{location}}',
        startDateLabel: 'Tanggal Mulai',
        endDateLabel: 'Tanggal Selesai',
        applyRange: 'Terapkan Periode',
        dailyChartTitle: 'Perubahan Qty Harian',
        cumulativeChartTitle: 'Qty Kumulatif',
        combinedChartTitle: 'Perubahan Harian & Tren Kumulatif',
        dailyChartLegend: 'Perubahan Qty',
        cumulativeChartLegend: 'Qty Kumulatif',
        noData: 'Tidak ada data pada periode ini.',
        fetchError: 'Gagal memuat data grafik.',
        invalidRange: 'Tanggal mulai tidak boleh lebih akhir dari tanggal selesai.',
        locationRequired: 'Informasi lokasi diperlukan untuk melihat grafik.'
      }
    },
    adjustment: {
      title: 'Pergerakan Inventaris',
      form: {
        title: 'Daftarkan Pergerakan'
      },
      list: {
        title: 'Riwayat Pergerakan Inventaris',
        createdAt: 'Waktu Dibuat',
        txTime: 'Waktu Pergerakan',
        txType: 'Jenis Pergerakan Inventaris',
        txSubtype: 'Subtipe',
        item: 'Item',
        qty: 'Quantity',
        uom: 'Satuan',
        fromLocation: 'Lokasi Asal',
        toLocation: 'Lokasi Tujuan',
        inventoryStatus: 'Status Stok',
        currency: 'Mata Uang',
        note: 'Note',
        searchPlaceholder: 'Cari item, jenis, status, catatan...',
        selectItem: 'Pilih item',
        searchHint: 'Item harus dipilih. Periode pencarian maksimal 1 tahun.',
        createdAtRange: 'Waktu input sistem',
        txTimeStart: 'Waktu mulai pergerakan',
        txTimeEnd: 'Waktu selesai pergerakan'
      },
      fields: {
        txTime: 'Waktu Pergerakan Inventaris',
        txType: 'Jenis Pergerakan Inventaris',
        docType: 'Jenis Dokumen',
        docId: 'ID Dokumen',
        item: 'Item',
        lotId: 'LOT',
        fromLocation: 'Lokasi Asal',
        toLocation: 'Lokasi Tujuan',
        qty: 'Quantity',
        uom: 'Satuan',
        unitCost: 'Biaya Satuan',
        currency: 'Mata Uang',
        inventoryStatus: 'Status Stok',
        note: 'Note',
        noLocation: 'Tidak ada'
      },
      txTypes: {
        receipt: 'Penerimaan',
        issue: 'Pengeluaran',
        transfer: 'Transfer',
        adjustment: 'Penyesuaian',
        productionConsume: 'Konsumsi Produksi',
        productionOutput: 'Output Produksi'
      },
      txSubtypes: {
        normal: 'Normal',
        void: 'Void',
        reversal: 'Reversal'
      },
      inventoryStatus: {
        available: 'Tersedia',
        reserved: 'Reservasi',
        wip: 'WIP',
        qcHold: 'QC Hold',
        damaged: 'Rusak'
      },
      add: {
        title: 'Daftarkan Pergerakan',
        confirmMessage: 'Apakah Anda ingin mendaftarkan pergerakan ini?',
        success: 'Pergerakan berhasil didaftarkan.'
      },
      edit: {
        title: 'Ubah Pergerakan',
        confirmMessage: 'Apakah Anda ingin memperbarui pergerakan ini?',
        success: 'Pergerakan berhasil diperbarui.'
      },
      validation: {
        required: 'Harap isi bidang yang wajib diisi.',
        invalidNumber: 'Masukkan angka yang valid.',
        bothLocationsRequired: 'Silakan isi minimal salah satu Lokasi Asal atau Lokasi Tujuan.',
        itemRequired: 'Harap pilih item.',
        dateRange: 'Tanggal mulai harus sebelum atau sama dengan tanggal akhir.',
        maxDateRange: 'Periode pencarian tidak boleh lebih dari 365 hari.'
      },
      delete: {
        title: 'Proses Reversal Pergerakan Inventaris',
        confirmMessage: 'Apakah Anda ingin memproses reversal untuk pergerakan inventaris ini?',
        success: 'Proses reversal telah selesai.',
        receiptIssueWarning: 'Penghapusan tersedia di halaman Pendaftaran Penerimaan/Pengeluaran.'
      }
    },
    batchInput: {
      saveConfirm: {
        title: 'Konfirmasi Simpan',
        changedItems: 'Item yang Diubah',
        txTimeField: 'Waktu pergerakan stok',
        txTimeLabel: 'Waktu pergerakan stok saat ini: {{time}}',
        negativeValueError: 'Nilai negatif tidak dapat dimasukkan untuk penerimaan hari ini atau pengeluaran hari ini. Silakan lakukan proses reversal untuk kuantitas yang salah dimasukkan di halaman riwayat transaksi inventaris.'
      },
      title: 'Input Batch',
      snapshotPending: 'Tutup buku bulanan belum siap.',
      date: 'Tanggal',
      location: 'Lokasi',
      columns: {
        sku: 'SKU',
        name: 'Nama Item',
        previousBalance: 'Saldo Sebelumnya',
        todayReceipt: 'Penerimaan Hari Ini',
        todayIssue: 'Pengeluaran Hari Ini',
        todayBalance: 'Saldo Hari Ini',
        uom: 'Satuan'
      },
      saveSuccess: 'Data berhasil disimpan.',
      saveFailed: 'Gagal menyimpan data.',
      noChanges: 'Tidak Ada Perubahan',
      noChangesMessage: 'Tidak ada perubahan untuk disimpan.',
      toggleUomTooltip: 'Beralih antara UOM dasar dan UOM sekunder',
      baseUom: 'UOM Dasar',
      secondaryUom: 'UOM Sekunder',
      selectDateAndCategory: 'Silakan pilih tanggal dan kategori.',
      bulkJob: {
        title: 'Pemrosesan stok massal',
        jobId: 'ID Job',
        status: 'Status',
        pollingHint: 'Diproses secara asinkron di server. Harap tunggu hingga selesai.',
        lineIndex: 'Baris',
        error: 'Kesalahan',
        timeout: 'Waktu tunggu habis. Periksa hasil di riwayat transaksi inventaris.',
        statusFailed: 'Tidak dapat mengambil status job.',
        submitFailed: 'Tidak dapat mengirim job massal.',
        noJobId: 'Respons server tidak menyertakan ID job.',
        partialSuccess: 'Beberapa baris gagal ({{count}}). Silakan periksa daftar.',
        jobFailed: 'Job massal gagal.',
        chunkSummary: 'Chunk: {{completed}} / {{total}} selesai',
        lineSummary: 'Baris: sukses {{success}} · gagal {{failure}} · total {{total}}'
      }
    },
    lotBatch: {
      sharedBox: 'Box sama',
      tabs: {
        incoming: 'Registrasi LOT Masuk',
        outgoing: 'Registrasi LOT Keluar',
        batch: 'Pembuatan LOT Keluar Batch',
        batchComingSoon: 'Fitur registrasi keluar batch akan dikembangkan pada tahap berikutnya.'
      },
      vehicleAssignment: {
        title: 'Penugasan Kendaraan',
        adjustButton: 'Penugasan Kendaraan',
        workOrder: 'Daftar Permintaan Keluar',
        changeDate: 'Ubah Tanggal',
        batchChange: 'Perubahan Tanggal Batch',
        saveFailed: 'Gagal Menyimpan',
        saveFailedMessage: 'Terjadi kesalahan saat menyimpan penugasan kendaraan.',
        saveSuccess: 'Penyimpanan Selesai',
        saveSuccessMessage: 'Penugasan kendaraan berhasil disimpan.',
        truckList: 'Daftar TRUK',
        noTrucks: 'Tidak ada truk terdaftar.',
        time: 'Waktu',
        addDate: 'Tambah Tanggal',
        noLotForDate: 'Tidak ada LOT untuk dikirim pada tanggal ini.',
        itemCount: '{{count}} item',
        dropToAssign: 'Jatuhkan di sini untuk menetapkan kendaraan',
        dateTimeFormat: 'DD MMMM YYYY HH:mm',
        dateFormat: 'DD MMMM YYYY',
        days: {
          sun: 'Min',
          mon: 'Sen',
          tue: 'Sel',
          wed: 'Rab',
          thu: 'Kam',
          fri: 'Jum',
          sat: 'Sab'
        }
      },
      giLot: {
        batch: {
          create: 'Buat LOT Keluar',
          hasLotNo: 'Item yang dipilih sudah memiliki LOT NO.',
          lotNoToggleOn: 'Semua',
          lotNoToggleOff: 'Belum LOT',
          lotNoToggleHint:
            'Mati: hanya baris tanpa LOT NO. Nyala: tampilkan juga baris yang sudah punya LOT NO.',
          tableColumns: {
            reqId: 'REQ ID',
            reqDate: 'TGL REQ',
            delivery: 'PENGIRIMAN',
            customer: 'CUSTOMER',
            manager: 'KONTAK',
            qty: 'QTY',
            detail: 'DETAIL',
            box: 'BOX',
            lotNo: 'LOT NO',
            estTime: 'PERKIRAAN WAKTU',
            slot: 'SLOT',
            truck: 'TRUK',
            misc: 'LAIN-LAIN'
          },
          missingAttributes: {
            title: 'Atribut Hilang',
            message: 'Item berikut kehilangan atribut yang diperlukan untuk menghitung box dan berat:'
          },
          createSuccess: {
            title: 'Pembuatan Selesai',
            message: 'LOT Keluar telah berhasil dibuat.'
          },
          createError: {
            title: 'Kesalahan Pembuatan',
            message: 'Beberapa LOT Keluar gagal dibuat:',
            general: 'Terjadi kesalahan saat membuat LOT Keluar.'
          },
          edit: 'Edit LOT Keluar',
          update: 'Perbarui',
          editDescription: 'Mengedit {{count}} LOT Keluar yang dipilih. Anda dapat menyeret baris untuk mengubah urutan.',
          createDescription: 'Membuat LOT Keluar untuk {{count}} permintaan yang dipilih. Anda dapat menyeret baris untuk mengubah urutan.',
          labels: {
            requestId: 'ID Permintaan',
            delivery: 'Pengiriman',
            customer: 'Customer',
            manager: 'Kontak'
          },
          updateSuccess: {
            title: 'Pembaruan Selesai',
            message: 'LOT Keluar telah berhasil diperbarui.'
          },
          updateError: {
            title: 'Kesalahan Pembaruan',
            message: 'Beberapa LOT Keluar gagal diperbarui:',
            general: 'Terjadi kesalahan saat memperbarui LOT Keluar.'
          },
          editError: {
            title: 'Kesalahan Pengambilan',
            message: 'Tidak dapat mengambil data LOT Keluar.',
            general: 'Terjadi kesalahan saat mengambil data LOT Keluar.'
          },
          deleteConfirm: {
            title: 'Konfirmasi Hapus',
            message: 'Apakah Anda yakin ingin menghapus LOT Keluar ini?'
          },
          deleteSuccess: {
            title: 'Penghapusan Selesai',
            message: 'LOT Keluar telah berhasil dihapus.'
          },
          deleteError: {
            title: 'Kesalahan Penghapusan',
            message: 'Tidak dapat menemukan ID LOT Keluar.',
            general: 'Terjadi kesalahan saat menghapus LOT Keluar.'
          }
        },
        fields: {
          lotNo: 'Nomor LOT',
          expectedGiAt: 'Waktu Keluar yang Diharapkan',
          workShift: 'Slot Waktu Tenggat Kerja',
          workShiftOptions: {
            none: 'Tidak Dipilih',
            shift_00_03: '00:00 - 03:00',
            shift_03_06: '03:00 - 06:00',
            shift_06_09: '06:00 - 09:00',
            shift_09_12: '09:00 - 12:00',
            shift_12_15: '12:00 - 15:00',
            shift_15_18: '15:00 - 18:00',
            shift_18_21: '18:00 - 21:00',
            shift_21_24: '21:00 - 24:00'
          },
          docType: 'Jenis Dokumen',
          docId: 'ID Dokumen',
          deliveryId: 'ID Pengiriman',
          deliveryName: 'Nama Pengiriman',
          addressSection: 'Informasi Pengiriman',
          address1: 'Alamat 1',
          address2: 'Alamat 2',
          city: 'Kota',
          state: 'Provinsi',
          postcode: 'Kode Pos',
          country: 'Negara',
          lines: 'Baris Keluar',
          detail: 'Detail',
          attributes: 'Atribut',
          truck: 'Truk'
        }
      },
      fields: {
        item: 'Item',
        lotNo: 'Nomor LOT',
        lotNoMode: 'Opsi Nomor LOT',
        supplierLotNo: 'Nomor LOT Supplier',
        mfgDate: 'Tanggal Produksi',
        expiryDate: 'Tanggal Kedaluwarsa',
        qcStatus: 'Status QC',
        lotNoPrefix: 'Awalan Nomor LOT',
        category: 'Kategori',
        attributes: 'Atribut',
        createdAt: 'Waktu Dibuat LOT'
      },
      qcStatus: {
        available: 'Tersedia',
        reserved: 'Dipesan',
        wip: 'WIP',
        qcHold: 'QC Hold',
        damaged: 'Rusak'
      },
      list: {
        title: 'Daftar LOT'
      },
      form: {
        title: 'Daftar LOT',
        lotMode: {
          auto: 'Buat otomatis',
          manual: 'Gunakan LOT yang ada'
        },
        lotNoAutoHint: 'Masukkan awalan untuk membuat nomor LOT secara otomatis.',
        lotNoManualHint: 'Masukkan nomor LOT yang sudah diterbitkan.'
      },
      add: {
        title: 'Daftar LOT',
        confirmMessage: 'Apakah Anda ingin mendaftarkan LOT ini?',
        success: 'LOT telah didaftarkan.'
      },
      edit: {
        title: 'Edit LOT',
        confirmMessage: 'Apakah Anda ingin memperbarui LOT ini?',
        success: 'LOT telah diperbarui.'
      },
      validation: {
        required: 'Harap isi bidang yang wajib diisi.',
        itemRequired: 'Harap pilih item.',
        qcStatusRequired: 'Harap pilih status QC.',
        lotNoRequired: 'Harap masukkan nomor LOT.'
      },
      searchPlaceholder: 'Cari berdasarkan Nomor LOT, ID Item, Nomor LOT Supplier...'
    },
    giLot: {
      fields: {
        lotNo: 'Nomor LOT',
        expectedGiAt: 'Waktu Keluar yang Diharapkan',
        workShift: 'Slot Waktu Tenggat Kerja',
        workShiftOptions: {
          none: 'Tidak Dipilih',
          shift_00_03: '00:00 - 03:00',
          shift_03_06: '03:00 - 06:00',
          shift_06_09: '06:00 - 09:00',
          shift_09_12: '09:00 - 12:00',
          shift_12_15: '12:00 - 15:00',
          shift_15_18: '15:00 - 18:00',
          shift_18_21: '18:00 - 21:00',
          shift_21_24: '21:00 - 24:00'
        },
        docType: 'Jenis Dokumen',
        docId: 'ID Dokumen',
        deliveryId: 'ID Pengiriman',
        deliveryName: 'Nama Pengiriman',
        addressSection: 'Informasi Pengiriman',
        address1: 'Alamat 1',
        address2: 'Alamat 2',
        city: 'Kota',
        state: 'Provinsi',
        postcode: 'Kode Pos',
        country: 'Negara',
        lines: 'Baris Keluar',
        detail: 'Detail',
        attributes: 'Atribut',
        truck: 'Truk'
      },
      lines: {
        lineLabel: 'Baris GI {{index}}',
        item: 'Item',
        itemId: 'ID Item',
        qty: 'Quantity',
        qtyBox: 'Jumlah BOX',
        mfgDate: 'Tanggal Produksi',
        expiryDate: 'Tanggal Kedaluwarsa',
        qcStatus: 'Status QC',
        subOrderId: 'ID Sub Order'
      },
      docType: {
        gir: 'Permintaan Keluar',
        etc: 'ETC'
      },
      form: {
        title: 'Registrasi LOT Keluar'
      },
      add: {
        title: 'Registrasi LOT Keluar',
        confirmMessage: 'Apakah Anda ingin mendaftarkan LOT keluar ini?',
        success: 'LOT keluar telah didaftarkan.'
      },
      edit: {
        title: 'Edit LOT Keluar',
        confirmMessage: 'Apakah Anda ingin memperbarui LOT keluar ini?',
        success: 'LOT keluar telah diperbarui.'
      },
      delete: {
        title: 'Konfirmasi Hapus',
        confirmMessage: 'Apakah Anda yakin ingin menghapus data ini?'
      },
      list: {
        title: 'Daftar LOT Keluar'
      },
      validation: {
        linesRequired: 'Item dan jumlah wajib diisi untuk baris keluar.'
      },
      deliveryDialog: {
        title: 'Cari Pengiriman',
        searchPlaceholder: 'Cari berdasarkan ID Pengiriman, Nama, Alamat...'
      },
      searchPlaceholder: 'Cari berdasarkan Nomor LOT, ID Dokumen, dll...'
    },
    grLot: {
      fields: {
        supplier: 'Supplier',
        grDate: 'Tanggal Masuk Direncanakan',
        docType: 'Jenis Dokumen',
        docId: 'ID Dokumen',
        lines: 'Baris Masuk',
        attributes: 'Atribut'
      },
      lines: {
        lineLabel: 'Baris GR {{index}}',
        item: 'Item',
        uom: 'Unit',
        qty: 'Quantity',
        qtyBox: 'Jumlah BOX',
        supplierLotNo: 'Nomor LOT Supplier',
        mfgDate: 'Tanggal Produksi',
        expiryDate: 'Tanggal Kedaluwarsa',
        qcStatus: 'Status QC'
      },
      docType: {
        po: 'Purchase Order',
        etc: 'ETC'
      },
      validation: {
        linesRequired: 'Item dan jumlah wajib diisi untuk baris masuk.'
      }
    }
  },
  scm: {
    goodsReceipt: {
      list: {
        title: 'Daftar Penerimaan Barang',
        grDate: 'Tanggal GR',
        supplier: 'Pemasok',
        poId: 'ID PO',
        lines: 'Detail',
        note: 'Note',
        createdAt: 'Dibuat Pada',
        searchPlaceholder: 'Cari berdasarkan ID GR, Pemasok, ID PO, dll.'
      },
      form: {
        title: 'Pendaftaran Penerimaan Barang',
        lines: 'Detail',
        lineNo: 'Detail {{no}}'
      },
      fields: {
        lotNo: 'Nomor LOT',
        supplier: 'Pemasok',
        grDate: 'Tanggal GR',
        poId: 'ID PO',
        note: 'Note',
        customDocDate: 'Tanggal Registrasi Pabean',
        customDocType: 'Jenis Dokumen Pabean',
        customDocNo: 'Nomor Dokumen Pabean',
        customsSection: 'Informasi Pabean',
        item: 'Item',
        lot: 'LOT',
        qty: 'Quantity',
        uom: 'UOM',
        toLocation: 'Ke Lokasi',
        unitPrice: 'Harga Satuan',
        currency: 'Mata Uang',
        totalAmount: 'Total Jumlah'
      },
      add: {
        title: 'Daftarkan Penerimaan Barang',
        confirmMessage: 'Apakah Anda ingin mendaftarkan penerimaan barang baru?',
        success: 'Penerimaan barang telah didaftarkan.'
      },
      edit: {
        title: 'Edit Penerimaan Barang',
        confirmMessage: 'Apakah Anda ingin memperbarui penerimaan barang ini?',
        success: 'Penerimaan barang telah diperbarui.'
      },
      delete: {
        title: 'Batalkan Penerimaan Barang',
        confirmMessage: 'Apakah Anda ingin membatalkan penerimaan barang ini?'
      },
      validation: {
        required: 'Harap isi bidang yang wajib diisi.',
        atLeastOneLine: 'Setidaknya satu baris diperlukan.',
        lineRequired: 'Harap isi bidang yang wajib diisi untuk baris.'
      },
      lotDialog: {
        title: 'Pilih LOT GR',
        searchPlaceholder: 'Cari berdasarkan Nomor LOT, ID Item, dll...'
      }
    },
    goodsIssue: {
      list: {
        title: 'Daftar Pendaftaran Pengiriman',
        giTime: 'Waktu Pengiriman',
        toDelivery: 'Tujuan Pengiriman',
        giPostNo: 'Nomor Dokumen Pengiriman',
        outboundLotNo: 'Nomor LOT Pengiriman',
        customsDocNo: 'Nomor Dokumen Pabean',
        lines: 'Detail',
        remarks: 'Remarks',
        createdAt: 'Dibuat Pada',
        searchPlaceholder: 'Cari berdasarkan ID Pengiriman, Tujuan, Nomor Dokumen, dll.'
      },
      form: {
        title: 'Pendaftaran Pengiriman',
        lines: 'Detail',
        lineNo: 'Detail {{no}}'
      },
      fields: {
        toDelivery: 'Tujuan Pengiriman',
        giTime: 'Waktu Pengiriman',
        giPostNo: 'Nomor Dokumen Pengiriman',
        outboundLotNo: 'Nomor LOT Pengiriman',
        customsDocNo: 'Nomor Dokumen Pabean',
        customsReceiptNo: 'Nomor Penerimaan Pabean',
        remarks: 'Remarks',
        item: 'Item',
        lot: 'LOT',
        qty: 'Quantity',
        uom: 'UOM',
        fromLocation: 'Lokasi Pengiriman',
        subOrderId: 'ID Sub Order',
        selectedFiles: 'File yang Dipilih'
      },
      add: {
        title: 'Daftarkan Pengiriman',
        confirmMessage: 'Apakah Anda ingin mendaftarkan pengiriman baru?',
        success: 'Pengiriman telah didaftarkan.'
      },
      edit: {
        title: 'Edit Pengiriman',
        confirmMessage: 'Apakah Anda ingin memperbarui pengiriman ini?',
        success: 'Pengiriman telah diperbarui.'
      },
      delete: {
        title: 'Batalkan Pengiriman',
        confirmMessage: 'Apakah Anda ingin membatalkan pengiriman ini?'
      },
      validation: {
        required: 'Harap isi bidang yang wajib diisi.',
        atLeastOneLine: 'Setidaknya satu baris diperlukan.',
        lineRequired: 'Harap isi bidang yang wajib diisi untuk baris.'
      },
      tabs: {
        general: 'Pendaftaran Pengiriman Umum',
        batch: 'Pendaftaran Pengiriman Batch'
      },
      batch: {
        create: 'Pendaftaran Pengiriman Batch',
        edit: 'Edit Pendaftaran Pengiriman Batch',
        createDialog: {
          title: 'Pendaftaran Pengiriman Batch'
        },
        editDialog: {
          title: 'Edit Pendaftaran Pengiriman Batch'
        },
        submitting: 'Mendaftarkan pengiriman...',
        deleteAll: 'Hapus Semua',
        details: 'Detail',
        shipCustomsInfo: 'Pengiriman · Bea Cukai',
        confirmDelete: 'Hapus pengeluaran barang ini?',
        confirmDeleteAll: 'Hapus semua pengeluaran barang yang dipilih?',
        validation: {
          customsDocNoRequired: 'Nomor dokumen pabean wajib diisi.',
          fieldRequired: 'Bidang ini wajib diisi.'
        },
        createError: 'Terjadi kesalahan saat mendaftarkan pengiriman.',
        createFailed: 'Gagal membuat GI post untuk lot {{lotNo}}: {{errorMessage}}',
        truckColumn: 'TRUCK',
        completed: 'Completed',
        completedToggleOn: 'Semua',
        completedToggleOff: 'Tertunda',
        completedToggleHint:
          'Filter Completed: Tertunda hanya baris tanpa GI POST ID; Semua termasuk yang sudah diposting.',
        columns: {
          lotNo: 'LOT NO',
          estTime: 'Perkiraan waktu',
          delivery: 'Pengiriman',
          truck: 'Truk',
          detail: 'Detail',
          customDate: 'Tanggal bea cukai',
          customType: 'Jenis bea cukai',
          customNo: 'No. bea cukai',
          noExBC: 'No ExBC',
          giPostId: 'GI POST ID',
          giPostNo: 'GI POST NO',
          postAt: 'Diposting pada',
          updatedAt: 'Diperbarui pada'
        }
      },
      lotDetail: {
        title: 'Detail LOT Pengiriman',
        basicInfo: 'Informasi Dasar',
        lotLines: 'Baris LOT Pengiriman',
        shippingRequest: 'Informasi Permintaan Pengiriman',
        giRequest: 'Informasi Permintaan GI',
        orders: 'Informasi Pesanan',
        consumption: 'Informasi Konsumsi',
        production: 'Informasi Produksi',
        giPost: 'Informasi Post GI',
        fields: {
          lotNo: 'LOT NO',
          expectedGiAt: 'Waktu Pengiriman yang Diharapkan',
          workShift: 'Shift Kerja',
          docType: 'Jenis Dokumen',
          docId: 'ID Dokumen',
          delivery: 'Pengiriman',
          address1: 'Alamat 1',
          address2: 'Alamat 2',
          cityState: 'Kota, Provinsi',
          postcode: 'Kode Pos',
          attributes: 'Atribut',
          lineNo: 'No Baris',
          itemId: 'ID Item',
          itemName: 'Nama Item',
          qty: 'Qty',
          qtyBox: 'Jumlah Kotak',
          subOrderId: 'ID Sub Order',
          qcStatus: 'Status QC',
          mfgDate: 'Tanggal Produksi',
          expiryDate: 'Tanggal Kedaluwarsa',
          giRequestId: 'ID Permintaan GI',
          lines: 'Baris',
          orderId: 'ID Pesanan',
          buyer: 'Buyer',
          vendor: 'Vendor',
          manager: 'Manajer',
          deliveryField: 'Pengiriman',
          subOrders: 'Sub Orders',
          color: 'Warna',
          price: 'Harga',
          currency: 'Mata Uang',
          uom: 'UOM',
          weight: 'Berat(kg)',
          location: 'Lokasi',
          sourceTxName: 'Nama TX Sumber',
          workType: 'Jenis Pekerjaan',
          workId: 'ID Pekerjaan',
          giPostId: 'ID Post GI',
          giPostNo: 'No Post GI',
          giLotNo: 'GI-LOT-NO',
          giTime: 'Waktu GI',
          customsReceiptNo: 'Nomor Penerimaan',
          customDocType: 'Jenis Dokumen Kustom',
          registrationNo: 'Nomor Registrasi',
          noDocExbc: 'No Doc ExBC',
          customDocDate: 'Tanggal Dokumen Kustom',
          remarks: 'Remarks',
          uomId: 'ID UOM',
          fromLocationId: 'ID Lokasi Asal',
          lotId: 'ID Lot',
          unitPrice: 'Harga Satuan',
          grossWeight: 'Berat Kotor'
        }
      }
    },
    deliveryInfo: {
      downloadAttachment: 'Unduh lampiran',
      sections: {
        search: '1. Cari Pengiriman Keluar',
        completion: '2. Penyelesaian Pengiriman',
        completionEdit: '2. Ubah Penyelesaian Pengiriman'
      },
      search: {
        hint: 'Masukkan minimal {{min}} karakter nomor registrasi bea cukai untuk mencari.',
        optionalHint:
          'Opsional. Muat dari pencarian pengeluaran atau isi manual di bawah. (Pencarian minimal {{min}} karakter)',
        placeholder: 'Sebagian nomor bea cukai',
        minLength: 'Nomor bea cukai minimal {{min}} karakter.',
        noResults: 'Tidak ada hasil.',
        failed: 'Gagal mencari data pengiriman keluar.',
        action: 'Action',
        registered: 'Terdaftar'
      },
      load: {
        failed: 'Gagal memuat detail pengiriman keluar.',
        noLines: 'Tidak ada baris pengiriman keluar.'
      },
      fields: {
        customsRegistrationNo: 'No Registrasi Bea Cukai',
        deliveryStatus: 'Status Pengiriman',
        deliveryCompletedAt: 'Tanggal Selesai Pengiriman',
        suratJalanFiles: 'Scan Surat Jalan'
      },
      giContext: {
        label: 'Pengeluaran yang dimuat'
      },
      lines: {
        add: 'Tambah baris',
        itemPlaceholder: 'Cari item'
      },
      status: {
        pending: 'Menunggu',
        confirmed: 'Dikonfirmasi',
        rejected: 'Ditolak',
        cancelled: 'Dibatalkan'
      },
      files: {
        select: 'Pilih File',
        hint: 'Unggah file PDF atau gambar.',
        existing: 'Surat Jalan terdaftar'
      },
      submit: {
        button: 'Daftarkan Penyelesaian Pengiriman',
        updateButton: 'Ubah Penyelesaian Pengiriman',
        submitting: 'Mengirim...',
        updating: 'Memperbarui...',
        success: 'Penyelesaian pengiriman berhasil didaftarkan.',
        updateSuccess: 'Penyelesaian pengiriman berhasil diperbarui.',
        failed: 'Gagal mendaftarkan penyelesaian pengiriman.',
        noGiPost: 'Pilih data pengiriman keluar terlebih dahulu.',
        noLines: 'Masukkan minimal satu baris valid (item, qty, UOM).',
        noCustomsNo: 'Nomor registrasi bea cukai tidak ada.',
        noCompletionDate: 'Silakan pilih tanggal penyelesaian pengiriman.',
        filesRequired: 'Lampirkan minimal satu file scan Surat Jalan.'
      },
      email: {
        dialogTitle: 'Kirim Email',
        dialogSubtitle:
          'Apakah Anda ingin mengirim email ke penanggung jawab? Periksa isi di bawah lalu klik Kirim.',
        contentLanguage: 'Bahasa isi email',
        lang: {
          ko: '한국어',
          en: 'English',
          id: 'Bahasa Indonesia'
        },
        defaultSubject: 'DELIVERY NOTE {{destination}} {{date}}',
        from: 'Dari',
        fromSystemFixed: 'Pengirim sistem (konfigurasi server)',
        to: 'Kepada',
        cc: 'CC',
        subject: 'Subjek',
        body: 'Isi',
        bodyHelper: 'Teks di bawah akan dikirim sebagai isi email. Anda dapat mengeditnya bila perlu.',
        bodyIntro: 'Halo, berikut pemberitahuan penyelesaian pengiriman.',
        suratJalanNo: 'No. Surat Jalan',
        deliveryCompletedAt: 'Tanggal selesai pengiriman',
        deliveryDestination: 'Tujuan pengiriman',
        linesHeader: '[Kuantitas per item]',
        styleNo: 'Style No',
        item: 'Item',
        color: 'Warna',
        qty: 'Qty',
        noReplyNotice: '※ Email ini dikirim secara otomatis oleh sistem dan tidak dapat dibalas. Untuk pertanyaan, silakan hubungi penanggung jawab terkait.',
        loadingOrderMeta: 'Memuat detail pesanan...',
        emailListHint: 'Pisahkan beberapa alamat dengan koma, titik koma, atau baris baru',
        attachmentsTitle: 'Lampiran',
        attachmentsFixedHint:
          'Semua file Surat Jalan yang diunggah saat pendaftaran dilampirkan (tidak dapat diubah).',
        attachmentSizeLimit:
          'Batas lampiran: total maks {{total}}, per file maks {{perFile}}. Pengiriman diblokir jika melebihi.',
        noAttachments: 'Tidak ada lampiran.',
        sendButton: 'Kirim email',
        sending: 'Mengirim email...',
        sendSuccess: 'Email berhasil dikirim.',
        sendFailed: 'Gagal mengirim email.',
        toRequired: 'Masukkan minimal satu email penerima.',
        invalidEmails: 'Format {{field}} tidak valid: {{emails}}',
        attachmentSizeExceeded:
          'Ukuran lampiran melebihi batas. Kurangi file dan coba lagi.'
      },
      errors: {
        createFailed: 'Gagal mendaftarkan penyelesaian pengiriman.',
        fetchFailed: 'Gagal memuat penyelesaian pengiriman.',
        updateFailed: 'Gagal memperbarui penyelesaian pengiriman.'
      }
    },
    deliveryStatus: {
      filter: {
        title: 'Kondisi Pencarian'
      },
      columns: {
        deliveryStatus: 'Status Pengiriman',
        suratJalan: 'Surat Jalan'
      },
      status: {
        notRegistered: 'Belum Terdaftar'
      },
      table: {
        count: '{{count}} / {{total}} data',
        searchHint: 'Pilih rentang tanggal lalu cari.',
        endOfList: 'Akhir daftar.'
      },
      validation: {
        dateRequired: 'Masukkan tanggal mulai dan akhir.',
        dateRange: 'Tanggal mulai harus sebelum atau sama dengan tanggal akhir.'
      },
      errors: {
        fetchFailed: 'Gagal memuat status pengiriman.'
      }
    }
  },
  giRequest: {
    shippingMarkNote: {
      title: 'Catatan Shipping Mark',
      placeholder: 'Masukkan teks untuk shipping mark',
      download: 'Unduh',
      instruction: 'Seret style untuk memindahkannya antar grup. Jika teks kosong, CITY yang tampil.',
      group: 'Grup {{n}}',
      addGroup: 'Tambah Grup',
      removeGroup: 'Hapus Grup',
      styleCount: '{{count}} style',
      emptyGroup: 'Pindahkan style ke grup ini',
      autoGroupByRemark: 'Kelompokkan Otomatis per REMARK',
      columns: {
        style: 'STYLE',
        fileNo: 'FILE NO',
        item: 'ITEM',
        size: 'SIZE',
        dyeingNo: 'DYEING NO',
        color: 'COLOR',
        qty: 'QTY',
        remark: 'REMARK'
      }
    },
    tabs: {
      general: 'GI Umum',
      batch: 'Permintaan Massal',
      bulkList: 'Grup GI',
      dailyCalendar: 'Kalender Harian',
      requestStatus: 'Status Permintaan'
    },
    row: {
      requested: 'Selesai Permintaan',
      partial: 'Sebagian',
      fullyRequestedHint: 'Permintaan GI sepenuhnya\nTidak dapat ditambah'
    },
    qtyErrors: {
      title: 'Tidak dapat menerbitkan permintaan GI',
      empty: 'Jumlah kosong.',
      invalid: 'Jumlah bukan angka yang valid.',
      negative: 'Jumlah harus 0 atau lebih.',
      zero: 'Jumlah harus lebih dari 0.',
      decimal: 'Jumlah hanya mengizinkan hingga 2 desimal.',
      exceed: 'Jumlah melebihi kuantitas pesanan.',
      generalSummary: 'Jumlah melebihi kuantitas pesanan.',
      generalLineRemain: 'Sub-order {{subId}}: input {{qty}} > sisa {{remain}} (pesanan {{order}}, sudah diminta {{requested}})',
      generalLineOrder: 'Sub-order {{subId}}: input {{qty}} > kuantitas pesanan {{order}}'
    },
    bulkList: {
      fromDate: 'Dari',
      toDate: 'Sampai',
      giNo: 'No. GI',
      delivery: 'Delivery',
      plannedDate: 'Tanggal Rencana',
      lineCount: 'Jumlah Baris',
      lineCountChip: '{{count}}',
      summary: 'Ringkasan',
      subOrder: 'Sub Order',
      styleNo: 'Style',
      vendor: 'Vendor',
      dyeingNo: 'Dyeing No.',
      color: 'COLOR',
      item: 'Item',
      qty: 'QTY',
      downloadPackingList: 'Unduh Packing List',
      downloadPackingListExim: 'Packing List (EXIM)',
      downloadPackingListAccount: 'Packing List (ACCOUNTING)',
      downloadShippingMark: 'Shipping Mark',
      searchPrompt: 'Tekan Cari untuk memuat data.',
      dateRequired: 'Silakan masukkan tanggal mulai dan akhir.',
      invalidDateRange: 'Tanggal mulai tidak boleh lebih lambat dari tanggal akhir.',
      noLineToDownload: 'Tidak ada baris untuk diunduh.',
      deleteGi: 'Hapus Grup GI',
      deleteTitle: 'Hapus Grup GI',
      deleteConfirm: 'Hapus {{giNo}} ({{count}} baris)? Tindakan ini tidak dapat dibatalkan.',
      deleteAskShort: 'Hapus {{giNo}}?',
      deleteBlockedTitle: 'Tidak Dapat Menghapus Grup GI',
      deleteBlockedMessage: '{{giNo}} tidak dapat dihapus.',
      deleteBlockedHeading: 'Peringatan',
      deleteBlockedBody: 'GI ini terhubung dengan faktur. Setelah faktur diterbitkan, grup GI tidak dapat dihapus.',
      deleteBlockedBody1: 'GI ini terhubung dengan faktur.',
      deleteBlockedBody2: 'Setelah faktur diterbitkan, grup GI tidak dapat dihapus.',
      deleteInvoiceWarn: 'Peringatan: GI ini terhubung dengan faktur ({{nos}}). Penghapusan dapat memengaruhi konsistensi tampilan faktur.',
      deleteSuccess: 'Grup GI telah dihapus.',
      deleteFailed: 'Gagal menghapus grup GI.',
      deleteLine: 'Hapus pengiriman',
      lineDeleteTitle: 'Hapus Pengiriman',
      lineDeleteAsk: 'Hapus pengiriman sub_order {{subOrder}} dari {{giNo}}?',
      lineDeleteSuccess: 'Pengiriman telah dihapus.',
      lineDeleteFailed: 'Gagal menghapus pengiriman.',
      dailyTotalsHeading: 'Total Permintaan GI Harian'
    },
    box: {
      tabSubOrder: 'Ringkasan Sub Order',
      tabBox: 'Box',
      boxNo: 'No. Box',
      originalNo: 'No. Asli',
      finalNo: 'No. Akhir',
      status: 'Status',
      merged: 'Digabung',
      summary: '{{boxes}} box fisik ({{rows}} baris)',
      countChip: '{{count}} box',
      customBadge: 'Nomor diedit',
      none: 'Permintaan GI ini belum memiliki nomor box.',
      generate: 'Buat Nomor Box',
      edit: 'Edit Nomor',
      editTitle: 'Edit Nomor Box',
      save: 'Simpan',
      regenerate: 'Buat Ulang',
      regenerateTitle: 'Buat Ulang Box',
      regenerateConfirm: 'Semua nomor box yang diedit akan hilang. Lanjutkan?',
      previewHint: 'Nomor akan diurutkan ulang dari 1 saat disimpan. Periksa kolom No. Akhir.',
      loadFailed: 'Gagal memuat informasi box.',
      saveFailed: 'Gagal menyimpan nomor box.',
      generateFailed: 'Gagal membuat nomor box.',
      conflict: 'Pengguna lain mengubah lebih dulu. Memuat ulang.',
      lineDeleteRenumberWarn: 'Nomor box akan diurutkan ulang dari 1.',
      applyStyleOrder: 'Rapikan Nomor Box',
      multiGiPackingNotice: 'Beberapa permintaan GI disertakan, sehingga nomor CT digabungkan.'
    },
    mergePicker: {
      title: 'Pilih Tujuan Penggabungan',
      description: 'Beberapa permintaan GI yang ada memiliki tujuan dan tanggal rencana yang sama.\nPilih permintaan yang akan digabungkan, atau buat baru.',
      currentDelivery: 'Tujuan Saat Ini',
      currentItemsHeading: 'Baris yang Akan Ditambahkan',
      conflictNotice: '⚠ Pengiriman yang Anda tambahkan sudah ada di permintaan GI lain.\nUntuk menghindari duplikasi, Anda hanya bisa menggabungkan ke permintaan tersebut. Untuk memilih yang lain atau membuat baru, hapus (🗑) pengiriman yang ada terlebih dahulu.',
      markDelete: 'Hapus pengiriman ini (diterapkan saat konfirmasi)',
      cancelDelete: 'Batalkan hapus',
      plannedDate: 'Tanggal Rencana',
      lineCount: 'Jumlah GI',
      createNew: 'Buat sebagai permintaan GI baru',
      summaryTitle: 'Detail Permintaan GI Terpilih',
      linesHeading: 'Daftar GI',
      remarks: 'Remarks'
    },
    form: {
      title: 'Buat Permintaan GI',
      editTitle: 'Ubah Permintaan GI',
      confirmAddTitle: 'Buat Permintaan GI',
      confirmAddMessage: 'Apakah Anda ingin membuat permintaan GI ini?',
      addSuccess: 'Permintaan GI berhasil dibuat.',
      confirmEditTitle: 'Perbarui Permintaan GI',
      confirmEditMessage: 'Simpan perubahan yang telah dilakukan?',
      editSuccess: 'Permintaan GI berhasil diperbarui.',
      deliveryId: 'ID Pengiriman',
      plannedDispatchAt: 'Tanggal Rencana Pengiriman',
      remarks: 'Remarks',
      lines: 'Detail Baris',
      lineLabel: 'Baris {{index}}',
      docType: 'Jenis Dokumen',
      docRefNo: 'No. Referensi',
      item: 'Item',
      qty: 'Quantity',
      lotId: 'Lot',
      locationFrom: 'Lokasi Asal',
      rackFrom: 'Rak',
      separatePacking: 'Pengemasan Terpisah',
      splitShipment: 'Pisahkan Pengiriman',
      splitShipmentHint: 'Pisahkan sub-order yang sama dengan tanggal dan jumlah pengiriman berbeda',
      removeSplitGroup: 'Batalkan Pemisahan',
      deliveryInfo: 'Informasi Tujuan',
      deliveryName: 'Nama Tujuan',
      deliveryPartnerId: 'ID Partner',
      deliveryPartnerName: 'Nama Partner',
      deliveryPartnerCode: 'Kode Partner',
      deliveryShippingMark: 'Shipping Mark',
      deliveryDistrict: 'Wilayah',
      deliveryAddress: 'Alamat',
      deliveryAddress2: 'Alamat 2',
      deliveryPostcode: 'Kode Pos',
      deliveryCountryCode: 'Kode Negara',
      deliveryTaxId: 'NPWP',
      deliveryTaxType: 'Jenis ID Pajak',
      deliveryCustomsId: 'NITKU',
      deliveryCustomsType: 'Jenis ID Bea Cukai',
      deliverySpecification: 'Spesifikasi',
      deliveryCreatorRegion: 'Wilayah Pembuat',
      deliveryCreatedAt: 'Dibuat Pada',
      deliveryUpdatedAt: 'Diperbarui Pada'
    },
    displayFilter: 'Filter Tampilan',
    incomplete: 'Belum Selesai',
    requestable: 'Dapat Diminta',
    displayFilter: 'Filter Tampilan',
    incomplete: 'Belum Selesai',
    requestable: 'Dapat Diminta',
    createRequest: 'Permintaan GI',
    completedFilterTooltip: 'Jika aktif, baris dengan jumlah GI Req. disembunyikan.',
    editRequest: 'Edit Permintaan GI',
    updateRequest: 'Perbarui Permintaan GI',
    editInGeneralTab: 'Silakan edit dan hapus di tab Permintaan Umum.',
    request: 'Permintaan GI',
    vendor: 'Pemasok',
    manager: 'Kontak',
    unknownItem: 'Item Tidak Dikenal',
    totalRequestsWillBeCreated: 'Total {{count}} permintaan GI akan dibuat.',
    validation: {
      qtyEmpty: 'Jumlah untuk "{{itemName}}" dalam Permintaan GI {{requestNumber}} kosong.',
      qtyInvalid: 'Jumlah "{{qtyValue}}" untuk "{{itemName}}" dalam Permintaan GI {{requestNumber}} tidak dapat dikonversi ke angka.',
      qtyNegative: 'Jumlah untuk "{{itemName}}" dalam Permintaan GI {{requestNumber}} harus 0 atau lebih besar.',
      qtyDecimalPlaces: 'Jumlah untuk "{{itemName}}" dalam Permintaan GI {{requestNumber}} hanya dapat memiliki hingga 2 tempat desimal.',
      qtyInputError: 'Terjadi kesalahan input jumlah.'
    },
    errors: {
      createFailed: 'Gagal membuat permintaan GI.',
      createError: 'Terjadi kesalahan saat membuat permintaan GI.',
      partialCreateFailed: 'Beberapa permintaan GI gagal dibuat.',
      errorDetail: '- ID Pemasok: {{vendorId}}, ID Pengiriman: {{deliveryId}}\n  Kesalahan: {{error}}'
    },
    list: {
      title: 'Daftar Permintaan GI',
      id: 'ID Permintaan',
      plannedDispatchAt: 'Tanggal Rencana Pengiriman',
      plannedFrom: 'Rencana Dari',
      plannedTo: 'Rencana Sampai',
      delivery: 'Pengiriman',
      remarks: 'Remarks',
      approval: 'Persetujuan',
      lines: 'Detail',
      searchPlaceholder: 'Cari berdasarkan ID, pengiriman, catatan',
      qtyLabel: '{{qty}} EA',
      approved: 'Disetujui',
      pendingApproval: 'Menunggu Persetujuan'
    },
    validation: {
      required: 'Harap isi informasi yang diperlukan.',
      lineRequired: 'Setiap baris harus memiliki item dan jumlah.'
    },
    errors: {
      generic: 'Terjadi kesalahan saat memproses permintaan GI.'
    },
    packingList: {
      dialogTitle: 'Unduh Packing List',
      dialogTitleExim: 'Unduh Packing List (EXIM)',
      dialogTitleAccount: 'Unduh Packing List (ACCOUNTING)',
      dialogTitleShippingMark: 'Unduh Shipping Mark',
      accountFileSplit: 'Pisahkan unduhan per Customer / Manager / Delivery',
      dialogDescription: 'Pilih opsi kurs untuk konversi harga (USD → IDR)',
      useOrderRate: 'Gunakan kurs dari order',
      notSet: 'belum diatur',
      manualInput: 'Input manual :',
      manualPlaceholder: 'contoh: 15800',
      noConversion: 'Tanpa konversi (hanya USD)',
      download: 'Unduh',
      cancel: 'Batal',
      downloadFailed: 'Gagal mengunduh Packing List.',
      buttonTooltip: 'Unduh Excel Packing List'
    }
  },
  warning: {
    title: 'Peringatan'
  }
};